import CommonState from '../parameters/CommonState'
import { getObjectByCache, getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { Charge } from '@/class/model/act/Charge'
import { ChargeServiceTypeItem } from '@/class/cargo/model/parameters/ChargeServiceTypeItem'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as ChargeItemTarget from '@/class/cargo/model/parameters/ChargeItemTarget'
import * as ChargeMeasure from '../parameters/ChargeMeasure'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import { cacheName, cache } from '@/utils/cacheManager'
import StrUtils from '@/utils/StrUtils'
import { roundHalfUp, mergeArray, multiply } from '@/utils/commonUtil'
import { deepClone, getUuid, sortByMultiField, sortByMultiFieldAndOrder } from '@/utils'
import * as EQSize from '../parameters/EQSize'
import * as SystemConstants from '../parameters/SystemConstants'
import * as CargoDocConsts from '../parameters/CargoDocConsts'
import { Company } from '@/class/model/mdm/Company'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import * as NumberUtils from '@/utils/NumberUtils'
import { AgentCharge } from '@/class/model/act/AgentCharge'
import $store from '@/store'
import lang from '@/lang'
import { TabError } from '@/utils/class/TabError'
import { Message } from '@/utils/Message'
import { getTitleByCmpIdxList, queryTitleByCpmIdx } from '@/api/partner/title'
import { getChargeList } from '@/api/seaExport/seaExportJob'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import { getManifestGoods } from '@/api/seaExport/manifestInfo'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { getConversionValue } from '@/class/cargo/model/parameters/EqType'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { CHARGE_BUYING_AND_SELLING_PRICE, CHARGE_SOURCE_SPLIT } from '../parameters/SystemConstants'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { getCustomer } from '@/api/partner/customer'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { MessageBox } from 'element-ui'
import i18n from '@/lang'
import Vue from 'vue'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import { Job } from '@/class/model/booking/Job'
import { User } from '@/class/model/sys/User'
import { getLclSlavesAndManifests } from '@/api/seaExport/seaExportJob'
import checkPermission from '@/utils/permission'

/**
 * 费用来源
 */
export const CHARGE_SOURCE_OP = new CommonState(0, '操作', 'op')
export const CHARGE_SOURCE_WAREHOUSE = new CommonState(1, '仓库', 'wareHouse')
export const CHARGE_SOURCE_MOTORCADE = new CommonState(2, '车队', 'motorcade')
export const CHARGE_SOURCE_SOP = new CommonState(3, 'sop自动生成', 'SOP Create')
export const CHARGE_SOURCE_IMPORT_SYNC_EXPORT = new CommonState(4, '进口同步出口', 'Import sync Export')
export const CHARGE_SOURCE_EXPORT_SYNC_IMPORT = new CommonState(6, '出口转进口', 'Export to Import')

export const SE_FCL = new CommonState('FCL', '整箱', 'FCL')
export const SE_LCL = new CommonState('LCL', '自拼箱', 'LCL')
export const SE_BB = new CommonState('BB', '委托拼箱', 'BB')
export const SE_BC = new CommonState('BC', 'Buyer Consol', 'Buyer Consol')
export const SE_BULK = new CommonState('BULK', '散杂货', 'BULK')
export const BC_CARGO_TYPE_FCL = new CommonState('BCF', 'Buyer Console FCL', 'Buyer Console FCL')

export const CHARGE_NULL = new CommonState('', '', '')
export const CHARGE_US = new CommonState('US', '未提交', 'UnSubmit')
export const CHARGE_SH = new CommonState('SH', '提交主管', 'Submit to supervisor')
export const CHARGE_PS2 = new CommonState('PS2', '部分提交财务2', 'Partial submission finance 2')
export const CHARGE_PS1 = new CommonState('PS1', '部分提交财务1', 'Partial submission finance 1')
export const CHARGE_MS = new CommonState('MS', '改单提交', 'Change order submission')
export const CHARGE_MA2 = new CommonState('MA2', '部分项目经理审批2', 'Approval of some project managers 2')
export const CHARGE_MA1 = new CommonState('MA1', '部分项目经理审批1', 'Approved by some project managers')
export const CHARGE_MA = new CommonState('MA', '项目经理审批', 'Project manager approval')
export const CHARGE_ALL = new CommonState('AS', '全部提交财务', 'All submitted to finance')

/**
 * SAP费用状态列表
 */
export const CHARGE_SAP_LIST = new Set([
  CHARGE_US,
  CHARGE_SH,
  CHARGE_PS2,
  CHARGE_PS1,
  CHARGE_MS,
  CHARGE_MA2,
  CHARGE_MA1,
  CHARGE_MA,
  CHARGE_ALL
])

/**
 * 海运出口整拼类型
 */
export const CARGO_TYPE_SE = new Set([
  SE_FCL,
  SE_LCL,
  SE_BB,
  SE_BC,
  SE_BULK,
  BC_CARGO_TYPE_FCL
])

export const SI_FCL = new CommonState('FCL', '整箱', 'FCL')
export const SI_LCL = new CommonState('LCL', '拼箱', 'LCL')
export const SI_CON = new CommonState('CON', '集拼', 'Consolidation')
export const SI_POJ = new CommonState('POJ', '项目', 'POJ')
export const SI_PVE = new CommonState('PVE', '私人物品', 'PVE')

/**
 * 海运进口整拼类型
 */
export const CARGO_TYPE_SI = new Set([
  SI_FCL,
  SI_LCL,
  SI_CON,
  SI_POJ,
  SI_PVE
])

export const AI_CONSOLE = new CommonState(0, '一主多分', 'Console')
export const AI_B2B = new CommonState(2, '一主一分', 'Back To Back')
export const AI_DIRECT = new CommonState(1, '直单', 'Direct')

/**
 * 空运进口整拼类型
 */
export const CARGO_TYPE_AI = new Set([
  AI_CONSOLE,
  AI_B2B,
  AI_DIRECT
])

export class ChargeUtils {
  constructor() {
  }

  /**
     * 应用费用方案，单次
     * @param job
     * @param schemeDetails
     * @param chargeSource
     * @param billcWeight
     */
  static async applyChargeSchemeSingle(job, schemeDetail, lengthCost, lengthSelling, chargeSource = 0, billcWeight = false, seaEq = null, chargeBranchId = 0) {
    const charge = new Charge().fillDefaultValue().getData()
    charge.jobUuid = job.uuid
    charge.businessDate = job.businessDate
    charge.chargeItemId = schemeDetail.chargeItemId
    // CARGO-31003 在新增费用时，直接对特定的费用进行受控
    const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', schemeDetail.chargeItemId)
    charge.controlled = chargeItem?.controlled
    charge.needInvoice = chargeItem?.needInvoice
    let haveAccountId = false
    if (schemeDetail.accountId !== 0) {
      // 针对费用方案中存储的历史结算单位
      const chargeAccount = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', schemeDetail.accountId)
      if (chargeAccount) {
        haveAccountId = true
        charge.accountId = schemeDetail.accountId
        if (StrUtils.isEmpty(schemeDetail.invoiceTitle)) { charge.invoiceTitle = await Company.getCompanyName(charge.accountId) } else { charge.invoiceTitle = schemeDetail.invoiceTitle }
      }
    }
    if (!haveAccountId) {
      charge.accountId = this.getChargeAccount(job, schemeDetail.partnerType)
      charge.invoiceTitle = await Company.getCompanyName(charge.accountId)
    }
    // 国内国外
    await this.getChargeisOverseaNotControlledByConfig(charge)
    charge.measure = this.getMeasure(schemeDetail, seaEq)
    charge.currency = schemeDetail.currency
    charge.unitRate = schemeDetail.unitRate
    charge.receivable = schemeDetail.receivable
    charge.inputBy = $store.getters.userId
    charge.inputDate = new Date()
    charge.inputByDep = $store.getters.currentDeptId
    charge.branchId = $store.getters.currentOfficeId
    if (chargeBranchId) {
      charge.branchId = chargeBranchId
    }
    const localCurrency = RateUtil.localCurrencyByOfficeId(charge.branchId)
    charge.localCurrency = localCurrency
    charge.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, charge.currency, job, charge.branchId)
    charge.exchangeRate = NumberUtils.roundHalfUp(charge.exchangeRate, 8)// CARGO-7779
    // HQ币种/汇率
    charge.hqCurrency = RateUtil.getHqCurrency(charge.branchId)
    charge.hqRate = await RateUtil.getForeignExchangeRateByJob(charge.hqCurrency, localCurrency, job, charge.branchId)
    charge.quantity = 1
    charge.quantity = await this.getChargeQuantity(charge, job, schemeDetail, billcWeight, seaEq)
    charge.remarks = schemeDetail.remark
    charge.verifiedAmount = 0
    charge.chargeSource = chargeSource
    charge.unitPriceIncludeTax = schemeDetail.unitPriceIncludeTax
    charge.needInvoice = schemeDetail.needInvoice
    // CARGO-9492 税率以费用方案为准：方案配了税率(含 0 免税)即用方案值；仅当方案未维护税率(null/undefined)时才兜底取费用名称税率
    charge.taxRate = schemeDetail.taxRate != null ? schemeDetail.taxRate : 0
    if (schemeDetail.taxRate == null) {
      // CARGO-31015 兜底取费用名称税率
      const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
      charge.taxRate = chargeItem ? (chargeItem.taxRate || 0) : 0
      // if (!charge.receivable) {
      //   charge.taxRate = this.getChargeRate(charge.accountId)
      // } else {
      //   const office = $store.getters.currentOffice
      //   if (office && String(office.taxRate) !== 'NaN') {
      //     charge.taxRate = office.taxRate
      //   }
      // }
    }

    if (charge.amount === 0) {
      charge.amount = charge.unitRate * charge.quantity || 0
      if (Math.abs(charge.amount) < schemeDetail.minimum) {
        charge.amount = schemeDetail.minimum
      }
      // 计算RT
      // 举例：客户A  有98 TON货，放了10天，应收仓储费：  5X (98/5)取整X 10  =1000 HKG
      if ((job.lob === SystemConstants.SE.code || job.lob === SystemConstants.SI.code) && schemeDetail.unitStep > 0 && job.chargeWeight > 0 &&
        (schemeDetail.measure === ChargeMeasure.WGT_CHARGE_MEASURE.code || schemeDetail.measure === ChargeMeasure.WGTT_CHARGE_MEASURE.code || schemeDetail.measure === ChargeMeasure.WGTX_CHARGE_MEASURE.code || schemeDetail.measure === ChargeMeasure.VOL_CHARGE_MEASURE.code)) {
        let ton = job.chargeWeight
        if (schemeDetail.measure === ChargeMeasure.WGT_CHARGE_MEASURE.code) {
          const weight = this.getChargeWeightValueType(true) === 0 ? job.weightActual : job.weightContract
          ton = weight / 1000
          if (ton < 1) {
            ton = 1
          }
        } else if (schemeDetail.measure === ChargeMeasure.WGTT_CHARGE_MEASURE.code) {
          if (job.lob === 'SE' && BillType.MERGE_BILL_TYPE.code === job.typeHBL) {
            const hbl2 = job.seaCargoDoc.find(p => p.docType === CargoDocConsts.HBL2)
            if (hbl2 && hbl2.weight) {
              ton = hbl2.weight / 1000
            }
          } else {
            const weight = this.getChargeWeightValueType(true) === 0 ? job.weightActual : job.weightContract
            ton = weight / 1000
          }
          if (ton < 1) {
            ton = 1
          }
        } else if (schemeDetail.measure === ChargeMeasure.VOL_CHARGE_MEASURE.code) {
          ton = this.getVOLQuantity(job)
        }
        ton = await this.getQuantityByChargeWeightValueType2(job, ton, schemeDetail.measure)
        const amount = charge.unitRate * ton / schemeDetail.unitStep
        charge.amount = amount || 0
        if (Math.abs(charge.amount) < schemeDetail.minimum) {
          charge.amount = schemeDetail.minimum
        }
      }
    }
    // 若是新悦租户且为并单
    if (String(cache.config.get('ToExoSystem')) === 'XYCW' && job.lob === 'SE' && BillType.MERGE_BILL_TYPE.code === job.typeHBL) {
      charge.quantity = await this.handleXyCharge(schemeDetail, job, charge.quantity)
    }
    // CARGO-9492 山九：费用方案可以区分含税价和不含税价
    if (charge.unitPriceIncludeTax) { // 单价含税
      this.calculateTaxAmount(charge, charge.amount, charge.taxRate)
    } else { // 单价不含税
      this.calculateTax(charge, charge.amount, charge.taxRate)
    }
    return charge
  }
  static async handleXyCharge(schemeDetail, job, curQuantity) {
    let quantity = curQuantity
    const hbl2 = job.seaCargoDoc.find(p => p.docType === CargoDocConsts.HBL2)
    if (schemeDetail.measure === ChargeMeasure.WGT_CHARGE_MEASURE.code) {
      if (hbl2 && hbl2.weight) {
        quantity = hbl2.weight
      }
    } else if (schemeDetail.measure === ChargeMeasure.VOL_CHARGE_MEASURE.code) {
      const hbl2 = job.seaCargoDoc.find(p => p.docType === CargoDocConsts.HBL2)
      if (hbl2 && hbl2.cubage) {
        quantity = hbl2.cubage
      }
    } else if (schemeDetail.measure === ChargeMeasure.WGTX_CHARGE_MEASURE.code) {
      const hbl2 = job.seaCargoDoc.find(p => p.docType === CargoDocConsts.HBL2)
      if (hbl2 && hbl2.chargeWeight) {
        quantity = hbl2.chargeWeight
      }
    } else if (schemeDetail.measure === ChargeMeasure.INSIDEPIECE_CHARGE_MEASURE.code) {
      const hbl2 = job.seaCargoDoc.find(p => p.docType === CargoDocConsts.HBL2)
      if (hbl2 && hbl2.insideQuantity) {
        quantity = hbl2.insideQuantity
      }
    }
    return quantity
  }

  /**
   * 应用费用方案
   */
  static async applyChargeScheme(job, schemeDetails, chargeSource = 0, billcWeight = false, chargeBranchId = 0) {
    // console.log('applyChargeScheme==schemeDetails', schemeDetails)
    const sortedList = this.sortSchemeDetails(schemeDetails)
    let lengthCost = 0 // 已有应收费用记录数
    let lengthSelling = 0 // 已有应付费用记录数
    const charges = [] // 新增的费用
    for (const jobCharge of job.charges) {
      if (jobCharge.receivable) {
        lengthCost += 1
      } else {
        lengthSelling += 1
      }
    }
    let checkSoNo = false
    for (const schemeDetail of sortedList) {
      if (schemeDetail.measure === ChargeMeasure.SONO_MEASURE.code) {
        checkSoNo = true
        break
      }
    }
    if (checkSoNo && !job.manifestInfoPage && !job.manifestInfos) {
      job.manifestInfos = await job.getManifestInfos()
      if (job.manifestInfos) {
        for (const m of job.manifestInfos) {
          m.manifestGoods = await getManifestGoods({ manifestInfoUuid: m.uuid }).then(res => res.data)
        }
      }
    }
    const truckingSchemes = []
    for (const schemeDetail of sortedList) {
      // 成基-最远城市、门点数、托盘数
      if (schemeDetail.measure === ChargeMeasure.ZYCS_MEASURE.code ||
          schemeDetail.measure === ChargeMeasure.TPS_MEASURE.code ||
          schemeDetail.measure === ChargeMeasure.MDS_MEASURE.code) {
        truckingSchemes.push(schemeDetail)
        continue
      }
      let charge = null
      if ((job.lob === SystemConstants.SE.code || job.lob === SystemConstants.SI.code || (job.lob === SystemConstants.RE.code || job.lob === 'RI')) && schemeDetail.measure === ChargeMeasure.BY_CNTR_CHARGE_MEASURE.code) {
        const seaEqList = []
        // HC 等于 HQ,去重处理
        this.setSeaEqList(job, seaEqList)
        for (const seaEQ of seaEqList) {
          if (this.checkSchemeDetailAndEQ(schemeDetail, seaEQ)) {
            charge = await this.applyChargeSchemeSingle(job, schemeDetail, lengthCost, lengthSelling, chargeSource, billcWeight, seaEQ, chargeBranchId)
            // 序号:递加
            if (charge.receivable) { // 应收
              lengthCost += 1
              charge.serialNumber = lengthCost
            } else { // 应付
              lengthSelling += 1
              charge.serialNumber = lengthSelling
            }
            charges.push(charge)
          }
        }
      } else {
        charge = await this.applyChargeSchemeSingle(job, schemeDetail, lengthCost, lengthSelling, chargeSource, billcWeight, null, chargeBranchId)
        // 序号:递加
        if (charge.receivable) { // 应收
          lengthCost += 1
          charge.serialNumber = lengthCost
        } else { // 应付
          lengthSelling += 1
          charge.serialNumber = lengthSelling
        }
        charges.push(charge)
      }
    }

    if (truckingSchemes.length > 0) {
      await this.getTruckingScheme(charges, job, truckingSchemes, lengthCost, lengthSelling, chargeSource)
    }
    return charges
  }

  /**
   * 成基 CARGO-22523 3.4.2. 增加计费单位计算规则
   * 这里只处理计费单位是 最远城市、门点数、托盘数
   * @param job
   * @param truckingSchemes
   * @param lengthCost
   * @param lengthSelling
   */
  static async getTruckingScheme(charges, job, truckingSchemes, lengthCost, lengthSelling, chargeSource) {
    if (!job.truckingPage || !job.trucking || job.trucking.length <= 0) {
      job.trucking = await job.getTrucking()
    }
    if (!job.trucking || job.trucking.length <= 0) return
    const useSchemes = [] // 有效的费用方案
    const truckingMap = new Map()
    for (const truck of job.trucking) {
      const truckCityCode = truck.cityCode
      if (!truckCityCode) continue
      truckingMap.set(truckCityCode, truck)
    }
    const chargeItemMap = new Map() // 存相同名称的费用方案键值对
    for (const detail of truckingSchemes) {
      if (detail.measure === ChargeMeasure.ZYCS_MEASURE.code) { // 最远城市
        let chargeItems = null
        const chargeItemId = detail.chargeItemId
        if (!chargeItemId) continue

        const cityCode = detail.cityCode
        // 这里排除掉 客户门点 中没有填写城市，费用方案 没有填写城市 以及 选择的费用方案明细中的城市 和 客户门点的城市不匹配
        if (!cityCode || !truckingMap.has(cityCode) || !truckingMap.get(cityCode)) {
          continue
        }

        // 这里计算出来是为了下面排序取最大使用
        let chargeAmount = detail.unitRate * detail.quantity || 0
        if (detail.minimum && Math.abs(chargeAmount) < detail.minimum) {
          chargeAmount = detail.minimum || 0
        }
        detail.chargeAmount = chargeAmount

        if (chargeItemMap.has(chargeItemId)) chargeItems = chargeItemMap.get(chargeItemId)
        if (!chargeItems) chargeItems = []
        chargeItems.push(detail)
        chargeItemMap.set(chargeItemId, chargeItems)
      } else if (detail.measure === ChargeMeasure.TPS_MEASURE.code) { // 托盘数
        for (const palletSumTruck of job.trucking) {
          if (!palletSumTruck.palletSum) continue
          const newDetail = deepClone(detail)
          newDetail.quantity = palletSumTruck.palletSum
          useSchemes.push(newDetail)
          continue
        }
      } else if (detail.measure === ChargeMeasure.MDS_MEASURE.code) { // 门点数
        // 若没有维护数值上下限，则不带，数值下限 不能 大于 上限
        if (!detail.rangeGe || !detail.rangeLt || (parseInt(detail.rangeLt) < parseInt(detail.rangeGe))) {
          continue
        }
        // 门点数要大于等于数值下限，小于数值上限
        if (job.trucking.length >= parseInt(detail.rangeGe) && job.trucking.length < parseInt(detail.rangeLt)) {
          useSchemes.push(detail)
          continue
        }
      }
    }

    // 最远城市
    for (const chargeItemKey of chargeItemMap.keys()) {
      const details = chargeItemMap.get(chargeItemKey)
      if (!details || details.length <= 0) continue
      const sortedDetails = sortByMultiField(details, ['chargeAmount'], true)
      if (!sortedDetails || sortedDetails.length <= 0) continue
      const sortedDetailOne = sortedDetails[0] // 上面倒序排列，第一条是最大的，
      useSchemes.push(sortedDetailOne) // 第一条是必须要的
      for (const sortedDetail of sortedDetails) {
        // 如果相同费用名称维护的数量*单价和第一条一样大，则新增多条
        if (sortedDetailOne.uuid !== sortedDetail.uuid && sortedDetailOne.chargeAmount === sortedDetail.chargeAmount) {
          useSchemes.push(sortedDetail)
        }
      }
    }
    if (useSchemes.length <= 0) return
    for (const useDetail of useSchemes) {
      const charge = await this.applyChargeSchemeSingleForCj(job, useDetail, lengthCost, lengthSelling, chargeSource)
      // 序号:递加
      if (charge.receivable) { // 应收
        lengthCost += 1
        charge.serialNumber = lengthCost
      } else { // 应付
        lengthSelling += 1
        charge.serialNumber = lengthSelling
      }
      charges.push(charge)
    }
  }

  /**
   * 应用费用方案，成基
   * @param job
   * @param schemeDetails
   * @param chargeSource
   * @param billcWeight
   */
  static async applyChargeSchemeSingleForCj(job, schemeDetail, lengthCost, lengthSelling, chargeSource = 0) {
    const charge = new Charge().fillDefaultValue().getData()
    charge.jobUuid = job.uuid
    charge.businessDate = job.businessDate
    charge.chargeItemId = schemeDetail.chargeItemId
    if (schemeDetail.accountId !== 0) {
      charge.accountId = schemeDetail.accountId
      if (StrUtils.isEmpty(schemeDetail.invoiceTitle)) { charge.invoiceTitle = await Company.getCompanyName(charge.accountId) } else { charge.invoiceTitle = schemeDetail.invoiceTitle }
    } else {
      charge.accountId = this.getChargeAccount(job, schemeDetail.partnerType)
      charge.invoiceTitle = await Company.getCompanyName(charge.accountId)
    }
    // 国内国外
    await this.getChargeisOverseaNotControlledByConfig(charge)
    charge.measure = this.getMeasure(schemeDetail, null)
    charge.currency = schemeDetail.currency
    charge.unitRate = schemeDetail.unitRate
    charge.receivable = schemeDetail.receivable
    charge.inputBy = $store.getters.userId
    charge.inputDate = new Date()
    charge.inputByDep = $store.getters.currentDeptId
    charge.branchId = $store.getters.currentOfficeId
    const localCurrency = RateUtil.localCurrencyByOffice()
    charge.localCurrency = localCurrency
    charge.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, charge.currency, job, charge.branchId)
    charge.exchangeRate = NumberUtils.roundHalfUp(charge.exchangeRate, 8)// CARGO-7779
    // HQ币种/汇率
    charge.hqCurrency = RateUtil.getHqCurrency(charge.branchId)
    charge.hqRate = await RateUtil.getForeignExchangeRateByJob(charge.hqCurrency, localCurrency, job, charge.branchId)
    charge.quantity = schemeDetail.quantity || 1
    charge.remarks = schemeDetail.remark
    charge.verifiedAmount = 0
    charge.chargeSource = chargeSource
    charge.unitPriceIncludeTax = schemeDetail.unitPriceIncludeTax
    charge.taxRate = schemeDetail.taxRate || 0
    if (!charge.taxRate || charge.taxRate <= 0) { // 税率取值：优先取费用方案维护的，没有维护再按原系统逻辑走
      if (!charge.receivable) {
        charge.taxRate = this.getChargeRate(charge.accountId)
      } else {
        const office = $store.getters.currentOffice
        if (office && String(office.taxRate) !== 'NaN') {
          charge.taxRate = office.taxRate
        }
      }
    }

    if (charge.amount === 0) {
      charge.amount = charge.unitRate * charge.quantity || 0
      if (Math.abs(charge.amount) < schemeDetail.minimum) {
        charge.amount = schemeDetail.minimum
      }
    }
    // CARGO-9492 山九：费用方案可以区分含税价和不含税价
    if (charge.unitPriceIncludeTax) { // 单价含税
      this.calculateTaxAmount(charge, charge.amount, charge.taxRate)
    } else { // 单价不含税
      this.calculateTax(charge, charge.amount, charge.taxRate)
    }
    return charge
  }

  static setSeaEqList(job, seaEqList) {
    for (const data of job.seaEQ) {
      const key = data.eqSize + '’' + getConversionValue(data.eqType)
      let isE = false
      for (const newData of seaEqList) {
        const newKey = newData.eqSize + '’' + getConversionValue(newData.eqType)
        if (key === newKey) {
          newData.eqQuantity += data.eqQuantity
          isE = true
        }
      }
      if (!isE) {
        seaEqList.push({ ...data })
      }
    }
  }
  static checkSchemeDetailAndEQ(schemeDetail, seaEq) {
    let flag = false
    const schemeDetailEqType = getConversionValue(schemeDetail.eqType)
    const seaEqType = getConversionValue(seaEq.eqType)
    if (schemeDetailEqType === seaEqType && (schemeDetail.eqSize === seaEq.eqSize || StrUtils.isEmpty(schemeDetail.eqSize))) {
      flag = true
    } else if (schemeDetail.eqSize === seaEq.eqSize && (schemeDetailEqType === seaEqType || StrUtils.isEmpty(schemeDetailEqType))) { flag = true }
    return flag
  }

  static getMeasure(schemeDetail, seaEq = null) {
    let measure = ''
    if (schemeDetail && schemeDetail.measure) {
      // if (schemeDetail.measure === ChargeMeasure.BY_CNTR_CHARGE_MEASURE.code) { measure = this.eqToChargeMeasure(seaEq) } else { measure = schemeDetail.measure }
      if (schemeDetail.measure === ChargeMeasure.BY_CNTR_CHARGE_MEASURE.code) { measure = this.eqToChargeMeasureNew(seaEq, schemeDetail) } else { measure = schemeDetail.measure }
    }
    return measure
  }

  /**
   * 有箱子，则根据箱子和费用箱型箱种进行匹配返回计费单位
   * @param schemeDetail
   * @param seaEq
   * @return
   */
  static eqToChargeMeasure(seaEq) {
    let measure = ''
    if (seaEq === null) { return measure }
    switch (seaEq.eqSize) {
      case EQSize.EQ20_EQ_SIZE.code:
        measure = ChargeMeasure.C20_CHARGE_MEASURE.code
        break
      case EQSize.EQ40_EQ_SIZE.code:
        if (seaEq.EQtype === 'HC') { measure = ChargeMeasure.C40H_CHARGE_MEASURE.code } else { measure = ChargeMeasure.C40_CHARGE_MEASURE.code }
        break
      case EQSize.EQ45_EQ_SIZE.code:
        measure = ChargeMeasure.C45_CHARGE_MEASURE.code
        break
    }
    return measure
  }

  static eqToChargeMeasureNew(seaEq, schemeDetail) {
    let measure = ''
    if (seaEq === null) { return measure }
    if (schemeDetail.eqSize === seaEq.eqSize && getConversionValue(schemeDetail.eqType) === getConversionValue(seaEq.eqType)) {
      const firstStr = schemeDetail.eqSize + '’' + schemeDetail.eqType
      const twoStr = schemeDetail.eqSize + '‘' + schemeDetail.eqType
      const threeStr = schemeDetail.eqSize + schemeDetail.eqType
      const chargeUnits = getCacheListByKey(basicCacheKeys.basic_data_ChargeUnit)
      for (const chargeUnit of chargeUnits) {
        if ((chargeUnit.chineseName === firstStr || chargeUnit.englishName === firstStr) || (chargeUnit.chineseName === twoStr || chargeUnit.englishName === twoStr) || (chargeUnit.chineseName === threeStr || chargeUnit.englishName === threeStr)) {
          measure = chargeUnit.code
        }
      }
    }
    if (measure === '') {
      switch (seaEq.eqSize) {
        case EQSize.EQ20_EQ_SIZE.code:
          measure = ChargeMeasure.C20_CHARGE_MEASURE.code
          break
        case EQSize.EQ40_EQ_SIZE.code:
          if (seaEq.EQtype === 'HC') { measure = ChargeMeasure.C40H_CHARGE_MEASURE.code } else { measure = ChargeMeasure.C40_CHARGE_MEASURE.code }
          break
        case EQSize.EQ45_EQ_SIZE.code:
          measure = ChargeMeasure.C45_CHARGE_MEASURE.code
          break
      }
    }
    return measure
  }

  /**
   * 对费用方案明细按leve排序
   */
  static sortSchemeDetails(details) {
    const sortDetails = sortByMultiField(details, ['level'], false)
    return sortDetails
  }

  static async applyChargeSchemeForAgentCharge(billing, schemeDetails, chargeSource = 0, billcWeight = false) {
    if (billing === null || billing.jobUuid === '' || schemeDetails == null || schemeDetails.length === 0) { return }
    const sortedList = ChargeUtils.sortSchemeDetails(schemeDetails)

    const length = billing.agentCharge.length // 已有费用记录数
    const job = billing.job
    for (const schemeDetail of sortedList) {
      if (schemeDetail.measure === ChargeMeasure.BY_CNTR_CHARGE_MEASURE.code) {
        for (const seaEQ of job.seaEQ) {
          if (this.checkSchemeDetailAndEQ(schemeDetail, seaEQ)) {
            await this.applyChargeSchemeForAgentChargeSingle(billing, schemeDetail, length, seaEQ)
          }
        }
      } else { await this.applyChargeSchemeForAgentChargeSingle(billing, schemeDetail, length) }
    }
  }

  static async applyChargeSchemeForAgentChargeSingle(billing, schemeDetail, length, seaEQ = null) {
    const charge = new AgentCharge().fillDefaultValue().getData()
    charge.billingUuid = billing.uuid
    charge.jobUuid = billing.jobUuid
    charge.job = billing.job
    charge.ar = schemeDetail.receivable
    charge.receivable = schemeDetail.receivable
    charge.chargeItemId = schemeDetail.chargeItemId
    charge.type = this.getMeasure(schemeDetail, seaEQ)
    charge.measure = charge.type
    charge.currency = schemeDetail.currency
    charge.unitPrice = schemeDetail.unitRate
    charge.unitRate = schemeDetail.unitRate
    charge.quantity = await ChargeUtils.getAgentChargeQuantity(charge, billing.job, schemeDetail, parseInt(cache.config.get('GetHBLcWeight')) === 1, seaEQ)
    charge.amount = Math.max(charge.unitRate * charge.quantity, schemeDetail.minimum)
    if ((charge.job.lob === SystemConstants.SE.code || charge.job.lob === SystemConstants.SI.code) && schemeDetail.unitStep > 0 && charge.job.chargeWeight > 0 &&
      (schemeDetail.measure === ChargeMeasure.WGT_CHARGE_MEASURE.code || schemeDetail.measure === ChargeMeasure.WGT_CHARGE_MEASURE.code || schemeDetail.measure === ChargeMeasure.WGTX_CHARGE_MEASURE.code || schemeDetail.measure === ChargeMeasure.VOL_CHARGE_MEASURE.code)) {
      let ton = charge.job.chargeWeight
      if (schemeDetail.measure === ChargeMeasure.WGT_CHARGE_MEASURE.code || schemeDetail.measure === ChargeMeasure.WGT_CHARGE_MEASURE.code) {
        const weight = this.getChargeWeightValueType(true) === 0 ? charge.job.weightActual : charge.job.weightContract
        ton = weight / 1000
        if (ton < 1) {
          ton = 1
        }
      }
      ton = await this.getQuantityByChargeWeightValueType2(billing.job, ton, schemeDetail.measure)
      const amount = charge.unitRate * ton / schemeDetail.unitStep
      charge.amount = Math.max(amount, schemeDetail.minimum)
    }
    charge.percentage = true
    charge.inputBy = billing.inputBy
    charge.inputDate = billing.inputDate
    charge.rate = billing.rate
    charge.serialNumber = schemeDetail.level + length // 序号:递加
    // CARGO-36375 代理分层账单中，使用费用方案，备注未代入
    charge.remark = schemeDetail.remark || ''
    billing.agentCharge.push(charge)
  }

  /**
     * 输入不含税价，税额和其他时计算
     */
  static calculateTax(cost, amount, taxRate, isExcluding = false) {
    amount = RateUtil.getAmountByCurrency(amount, cost.currency)
    const newAmount = NumberUtils.ToFixed2(amount, 2)
    let oldAmount = newAmount + (newAmount * (taxRate / 100))
    oldAmount = RateUtil.getAmountByCurrency(oldAmount, cost.currency)
    cost.excludingTaxAmount = newAmount
    cost.amount = NumberUtils.ToFixed2(oldAmount, 2)
    let taxAmount = cost.amount - cost.excludingTaxAmount
    taxAmount = RateUtil.getAmountByCurrency(taxAmount, cost.currency)
    cost.taxAmount = Number(taxAmount.toFixed(2))
    const costQuantity = Number(cost.quantity)
    if (isExcluding && costQuantity !== 0) {
      // CARGO-4980 但是是否含税
      if (cost.unitPriceIncludeTax) {
        cost.unitRate = NumberUtils.ToFixed2(oldAmount / costQuantity, 3)
      } else {
        cost.unitRate = NumberUtils.ToFixed2(amount / costQuantity, 3)
      }
    }
  }

  /**
   * @param value
   * @param digits
   * @returns {*}
   * @constructor
   */
  static ToFixed(value, digits = 0) {
    return NumberUtils.ToFixed(value, digits)
  }

  static async calculateExchangeRate(charge, job) {
    const localCurrency = RateUtil.localCurrencyByOfficeId(charge.branchId)
    charge.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, charge.currency, job, charge.branchId)
    if (charge.exchangeRate) {
      charge.exchangeRate = NumberUtils.roundHalfUp(charge.exchangeRate, 8)
    }
  }

  /**
   * 输入含税价时计算
   * amount 含税价
   * taxRate 税率
   */
  static calculateTaxAmount(cost, amount, taxRate) {
    amount = RateUtil.getAmountByCurrency(amount, cost.currency)
    let excludingTaxAmount = amount / (1 + (taxRate / 100))
    excludingTaxAmount = RateUtil.getAmountByCurrency(excludingTaxAmount, cost.currency)
    cost.amount = NumberUtils.ToFixed2(amount, 2)
    cost.excludingTaxAmount = NumberUtils.ToFixed2(excludingTaxAmount, 2) // 不含税额
    let taxAmount = cost.amount - cost.excludingTaxAmount
    taxAmount = RateUtil.getAmountByCurrency(taxAmount, cost.currency)
    cost.taxAmount = Number(taxAmount.toFixed(2))
    const costQuantity = Number(cost.quantity)
    if (costQuantity !== 0) {
      // CARGO-4980 但是是否含税
      if (cost.unitPriceIncludeTax) {
        cost.unitRate = NumberUtils.ToFixed2(amount / costQuantity, 3)
      } else {
        cost.unitRate = NumberUtils.ToFixed2(excludingTaxAmount / costQuantity, 3)
      }
    }
  }

  /**
     * 四舍五入
     */
  static getRoundingValue(value) {
    return Number(this.ToFixed(value, 2))
  }

  /**
   * 获取税率
   */
  static changeItemRate(item) {
    const office = $store.getters.currentOffice
    if (!item.receivable) {
      item.taxRate = this.getChargeRate(item.accountId)
    } else {
      if (office && String(office.taxRate) !== 'NaN') {
        item.taxRate = office.taxRate
      } else {
        item.taxRate = 0
      }
    }
  }

  /**
   * 获取合作伙伴税率
   */
  static getChargeRate(accountId) {
    const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', accountId)
    if (company && company.taxRate !== 0 && String(company.taxRate) !== 'NaN') {
      return company.taxRate
    }
    return 0
  }

  /**
   * 获取费用创建时的税率
   */
  static getTaxRateAtCreateCharge(item) {
    let taxRate = 0
    if (item.accountId > 0) {
      taxRate = this.getChargeRate(item.accountId)
    }
    if (item.receivable) {
      if (taxRate === 0) {
        const office = $store.getters.currentOffice
        if (office && String(office.taxRate) !== 'NaN') {
          taxRate = office.taxRate
        }
      }
    }
    return taxRate
  }

  /**
   * 通过结算对象设置费用税率
   */
  static changeChargeRateByAccountId(charge) {
    const taxRate = this.getChargeRate(charge.accountId)
    if (taxRate) {
      charge.taxRate = taxRate
    }
  }

  /**
   * @private
   */
  static getChargeAccount(job, partnerType) {
    let accountId = 0
    switch (partnerType) {
      case ChargeConstants.ACCOUNT_CUSTOMER.code :
        accountId = job.customerId
        break

      case ChargeConstants.ACCOUNT_BOOKING_AGENT.code :
        accountId = job.bookingAgent
        break

      case ChargeConstants.TERMINAL_COMPANY.code : // 码头公司
        if (job.lob === 'SE' || job.lob === 'SI') {
          accountId = job.terminalCompany
        }
        break

      case ChargeConstants.ACCOUNT_CARRIER_AGENT.code :
        accountId = job.carrierAgentId
        break

      case ChargeConstants.ACCOUNT_CARRIER.code :
        accountId = job.carrierId
        break

      case ChargeConstants.ACCOUNT_CUSTOMS_BROKER.code :
        accountId = job.customsBroker
        break

      case ChargeConstants.ACCOUNT_OVERSEA_AGENT.code :
        if (job.lob === 'AI') {
          accountId = job.loadingAgentId
        } else {
          accountId = job.destinationAgent
        }
        break

      case ChargeConstants.ACCOUNT_WAREHOUSE.code :
        if (job.warehouseInfo && job.warehouseInfo.length > 0) { accountId = job.warehouseInfo[0].warehouseCmp }
        break

      case ChargeConstants.ACCOUNT_TRUCKING.code :
        if (job.trucking && job.trucking.length > 0) {
          for (const trucking of job.trucking) {
            if (trucking.truckingId !== 0) {
              accountId = trucking.carryingCmp
              break
            }
          }
        }
        break

      case ChargeConstants.FORWARDING_AGENT.code :
        accountId = job.forwardingAgent || 0
        break

      case ChargeConstants.NOMINATED_AGENT.code :
        accountId = job.designationAgent
        break

      case ChargeConstants.EXCHANGE_AGENT.code :
        accountId = job.exChangeAgent
        break

      case ChargeConstants.SHIPPER_ID.code :
        accountId = job.shipperId
        break
      case ChargeConstants.CONSIGNEE_ID.code :
        accountId = job.consigneeId
        break
      case ChargeConstants.NOITFY_ID.code :
        accountId = job.notifyId
        break

      default : break
    }
    return accountId
  }

  /**
   * 根据计费单位计算数量
   */
  static async getChargeQuantity(charge, job, schemeDetail, billcWeight = false, seaEQ = null) {
    let quantity = charge.quantity
    const combinedManifest = Number(cache.config.get('CombinedManifest')) === 1
    const soNoMap = {}
    switch (charge.measure) {
      case ChargeMeasure.WGT_CHARGE_MEASURE.code : {
        const weight = this.getChargeWeightValueType(true) === 0 ? job.weightActual : job.weightContract
        if (job.lob === 'AE') {
          quantity = weight
        } else if (job.lob === 'AI') {
          quantity = job.weightContract
        } else {
          quantity = weight / 1000
          if (quantity < 1) {
            quantity = 1
          }
        }
      }
        break
      case ChargeMeasure.WGTT_CHARGE_MEASURE.code : {
        const weight = this.getChargeWeightValueType(true) === 0 ? job.weightActual : job.weightContract
        if (job.lob === 'SE' && BillType.MERGE_BILL_TYPE.code === job.typeHBL) {
          const hbl2 = job.seaCargoDoc.find(p => p.docType === CargoDocConsts.HBL2)
          if (hbl2 && hbl2.weight) {
            quantity = hbl2.weight / 1000
          }
        } else if (job.lob === 'AE') {
          quantity = weight / 1000
        } else if (job.lob === 'AI') {
          quantity = job.weightContract / 1000
        } else {
          quantity = weight / 1000
          if (quantity < 1) {
            quantity = 1
          }
        }
      }
        break
      case ChargeMeasure.WGTX_CHARGE_MEASURE.code :
        if (job.lob === 'AE') {
          if (billcWeight) { quantity = await ChargeUtils.getMHLcWeight(charge.receivable, job) } else {
            quantity = new AirExportJob(job).cWeight
            // CARGO-7486 应付费用无法带入计费重量价, 和客户确认后应当取实际, 因此取消此处判断
            //                            if (charge.receivable) {
            //
            //                            } else {
            //                                const mawb:AirCargoDoc = AirExportJob(job).getCargoDoc(CargoDocConsts.MAWB, false);
            //                                quantity = mawb == null ? AirExportJob(job).cWeight : mawb.cWeight;
            //                            }
            //                            quantity = getQuantityForPbProportion2(quantity, AirExportJob(job), null, charge.receivable);
          }
          //                        quantity = JobUtils.safeWeight(quantity);
        } else {
          quantity = job.chargeWeight
        }

        break
      case ChargeMeasure.VOL_CHARGE_MEASURE.code :
        quantity = this.getVOLQuantity(job)
        break

      case ChargeMeasure.MIN_CHARGE_MEASURE.code :
      case ChargeMeasure.BOX_MEASURE.code :
      case ChargeMeasure.NML_CHARGE_MEASURE.code :
        quantity = 1
        break
      case ChargeMeasure.BL_CHARGE_MEASURE.code :
        quantity = 1
        break
      case ChargeMeasure.SHIPMENT_CHARGE_MEASURE.code :
        quantity = 1
        break

      case ChargeMeasure.CNTR_CHARGE_MEASURE.code :
        quantity = 0
        for (const seq of job.seaEQ) {
          quantity += seq.eqQuantity
        }
        break
      case ChargeMeasure.SONO_MEASURE.code :
        if (job.manifestInfos && job.manifestInfos.length > 0) {
          quantity = 0
          for (const man of job.manifestInfos) {
            if (combinedManifest) {
              if (man.delete) continue // 已删除舱单排除
              if (man.invalid) continue // 已作废舱单排除
            }
            if (man.manifestGoods) {
              for (const goods of man.manifestGoods) {
                if (goods.soNo && !goods.deleted && !soNoMap[goods.soNo]) {
                  soNoMap[goods.soNo] = true
                  quantity += 1
                }
              }
            }
          }
        }
        // 锦昶，主票BCF的时候，需要把小票的一起计算进去
        if (combinedManifest && job.uuid && job.masterFlag && job.containerLoadType === 'BCF') {
          const lclSlaves = await getLclSlavesAndManifests(job.uuid).then(res => res.data)
          if (lclSlaves && lclSlaves.length > 0) {
            // 主票没有预配信息，但是小票有，且小票的SONO有数据，此时数量要初始值为0，然后重新计算
            if (!job.manifestInfos || job.manifestInfos.length === 0) {
              const needInitQuantity = lclSlaves.some(slave =>
                  slave.manifestInfos?.some(manifest =>
                      manifest.manifestGoods?.some(goods => goods.soNo)
                  )
              )
              if (needInitQuantity) {
                quantity = 0
              }
            }
            for (const slave of lclSlaves) {
              if (slave.manifestInfos && slave.manifestInfos.length > 0) {
                for (const manifest of slave.manifestInfos) {
                  if (manifest.manifestGoods && manifest.manifestGoods.length > 0) {
                    for (const goods of manifest.manifestGoods) {
                      if (goods.soNo && !soNoMap[goods.soNo]) {
                        soNoMap[goods.soNo] = true
                        quantity += 1
                      }
                    }
                  }
                }
              }
            }
          }
        }
        break
      case ChargeMeasure.PIECE_CHARGE_MEASURE.code :
        if (job.lob === 'AE') {
          quantity = job.quantityActual
        } else if (job.lob === 'AI') {
          quantity = job.quantityContract
        } else if (job.lob === 'SE') {
          quantity = job.quantityActual
        } else if (job.lob === 'SI') {
          quantity = job.quantityContract
        } else if (job.lob === 'RE' || job.lob === 'RI') {
          quantity = job.quantityActual
        }
        break
      default :
        if (job.lob === 'SE' || job.lob === 'SI') {
          if (seaEQ) {
            quantity = this.getEQQuantity(charge.measure, job, schemeDetail.eqType, seaEQ)
          } else {
            // 现在 schemeDetail.eqType, seaEQ 只有在按箱型才可使用， 这里使用费用页签列表单位变更方法
            quantity = await this.getColumnEQQuantity(charge.measure, job)
          }
        }
        break
    }
    if (isNaN(quantity) || quantity === 0) { quantity = 1 }
    quantity = await this.getQuantityByChargeWeightValueType2(job, quantity, charge.measure)
    return quantity
  }

  /**
   * chargeWeightValueType 参数缺省值就是0
   * @param job
   * @returns {*}
   */
  static getVOLQuantity(job) {
    let quantity = 0.0
    if (job.lob === 'SE' || job.lob === 'SI' || job.lob === 'RE' || job.lob === 'RI') {
      if (this.getChargeWeightValueType(true) === 0) {
        quantity = job.chargeCubage > 0 ? job.chargeCubage : job.cubageActual
      } else {
        quantity = job.cubageContract
      }
    } else {
      if (job.lob === 'AE') {
        quantity = job.cubageActual
      } else {
        quantity = job.cubageContract
      }
    }
    return quantity
  }

  /**
   * @private
   */
  static async getAgentChargeQuantity(charge, job, schemeDetail = null, billcWeight = false, seaEQ = null) {
    let quantity = charge.quantity
    switch (charge.measure) {
      case ChargeMeasure.WGT_CHARGE_MEASURE.code : {
        const weight = this.getChargeWeightValueType(true) === 0 ? job.weightActual : job.weightContract
        if (job.lob === 'AE') {
          quantity = weight
        } else if (job.lob === 'AI') {
          quantity = job.weightContract
        } else {
          quantity = weight / 1000
          if (quantity < 1) {
            quantity = 1
          }
        }
      }
        break
      case ChargeMeasure.WGTT_CHARGE_MEASURE.code : {
        const weight = this.getChargeWeightValueType(true) === 0 ? job.weightActual : job.weightContract
        if (job.lob === 'SE' && BillType.MERGE_BILL_TYPE.code === job.typeHBL) {
          const hbl2 = job.seaCargoDoc.find(p => p.docType === CargoDocConsts.HBL2)
          if (hbl2 && hbl2.weight) {
            quantity = hbl2.weight / 1000
          }
        } else if (job.lob === 'AE') {
          quantity = weight / 1000
        } else if (job.lob === 'AI') {
          quantity = job.weightContract / 1000
        } else {
          quantity = weight / 1000
          if (quantity < 1) {
            quantity = 1
          }
        }
      }
        break
      case ChargeMeasure.WGTX_CHARGE_MEASURE.code :
        if (job.lob === 'AE') {
          if (billcWeight) {
            // todo 空运的
            quantity = ChargeUtils.getMHLcWeight(charge.receivable, job)
          } else {
            quantity = job.cWeight
          // CARGO-7486 应付费用无法带入计费重量价, 和客户确认后应当取实际, 因此取消此处判断
          //							if (charge.receivable){
          //
          //							}else{
          //                                const mawb:AirCargoDoc = AirExportJob(job).getCargoDoc(CargoDocConsts.MAWB, false);
          //                                quantity = mawb == null ? AirExportJob(job).cWeight : mawb.cWeight;
          //							}
          //                            quantity = getQuantityForPbProportion2(quantity, AirExportJob(job), null, charge.receivable);
          }
        //                        quantity = JobUtils.safeWeight(quantity);
        } else { quantity = job.chargeWeight }
        break
      case ChargeMeasure.PIECE_CHARGE_MEASURE.code :
        if (job.lob === 'AE') {
          quantity = job.quantityActual
        } else if (job.lob === 'AI') {
          quantity = job.quantityContract
        } else if (job.lob === 'SE') {
          quantity = job.quantityActual
        } else if (job.lob === 'SI') {
          quantity = job.quantityContract
        } else if (job.lob === 'RE' || job.lob === 'RI') {
          quantity = job.quantityActual
        }
        break
      case ChargeMeasure.VOL_CHARGE_MEASURE.code :
        quantity = this.getVOLQuantity(job)
        break

      case ChargeMeasure.MIN_CHARGE_MEASURE.code :
      case ChargeMeasure.BOX_MEASURE.code :
      case ChargeMeasure.NML_CHARGE_MEASURE.code :
        quantity = 1
        break
      case ChargeMeasure.BL_CHARGE_MEASURE.code :
        quantity = 1
        break
      case ChargeMeasure.SHIPMENT_CHARGE_MEASURE.code :
        quantity = 1
        break
      case ChargeMeasure.CNTR_CHARGE_MEASURE.code :
        quantity = 0
        for (const seq of job.seaEQ) {
          quantity += seq.eqQuantity
        }
        break

      default :
        if (job.lob === 'SE' || job.lob === 'SI') {
          if (schemeDetail) { quantity = this.getEQQuantity(charge.measure, job, schemeDetail.eqType, seaEQ) } else { quantity = this.getEQQuantity2(charge.measure, job, seaEQ) }
        }
        break
    }
    if (quantity < 1) { quantity = 1 }
    quantity = await this.getQuantityByChargeWeightValueType2(job, quantity, charge.measure)
    return quantity
  }

  /**
   * 应收取分单的计费重量,应付取制单的计费重量
   */
  static async getMHLcWeight(isReceivable, _job) {
    let quantity = 0.0
    let doc = null
    if (isReceivable) {
      doc = await new AirExportJob(_job).getCargoDoc(CargoDocConsts.HAWB, false)
      quantity = doc == null ? AirExportJob(_job).cWeight : doc.cWeight
    } else {
      doc = await new AirExportJob(_job).getCargoDoc(CargoDocConsts.MAWB, false)
      quantity = doc == null ? 0 : doc.cWeight
      //                quantity = getQuantityForPbProportion2(quantity, AirExportJob(_job), doc, receivable);
    }

    return quantity
  }

  // /**
  //  * 处理供应商分泡比例存在情况下
  //  * @param air
  //  * @param doc
  //  * @param receivable
  //  * @return
  //  */
  // static getQuantityForPbProportion2(quantity, air:AirExportJob, doc:AirCargoDoc, receivable) {
  //   if (air.pbProportion2 > 0 && !receivable) {
  //     if (doc == null) {
  //       quantity = JobUtils.calcChargeWeight(air.weightActual, air.cubageActual, true);
  //       quantity = ((quantity - air.weightActual) * air.pbProportion2 * 0.01) + air.weightActual;
  //     } else {
  //       quantity = JobUtils.calcChargeWeight(doc.weight, doc.cubage, true);
  //       quantity = ((quantity - doc.weight) * air.pbProportion2 * 0.01) + doc.weight;
  //     }
  //   }
  //   return quantity
  // }
  //
  /**
   * 统计箱量
   */
  static getEQQuantity(type, job, eqType, seaEQ = null) {
    if (seaEQ) { return seaEQ.eqQuantity }
    let n = 0
    for (const eq of job.seaEQ) {
      if (eq.eqType === eqType) {
        if (type === 'C20' && eq.eqSize === '20') { n = n + eq.eqQuantity } else if (type === 'C40' && eq.eqSize === '40') { n = n + eq.eqQuantity } else if (type === 'C40H' && eq.eqSize === '40') { n = n + eq.eqQuantity } else if (type === 'C45' && eq.eqSize === '45') { n = n + eq.eqQuantity }
      }
    }
    return n
  }

  static async getColumnEQQuantity(type, job) {
    let n = 0
    if (!job || !job.seaEQ) {
      await new Job(job).getSeaEQ()
    }
    if (!job.seaEQ) {
      return n
    }
    for (const eq of job.seaEQ) {
      if (type === 'C20' && eq.eqSize === '20') {
        n = n + eq.eqQuantity
      } else if (type === 'C40' && eq.eqSize === '40' && eq.eqType === 'GP') {
        n = n + eq.eqQuantity
      } else if (type === 'C40H' && eq.eqSize === '40' && eq.eqType === 'HC') {
        n = n + eq.eqQuantity
      } else if (type === 'C45' && eq.eqSize === '45') {
        n = n + eq.eqQuantity
      }
    }
    return n
  }

  static isEQ(schemeDetail, job) {
    const eqType = schemeDetail.eqType
    const eqSize = schemeDetail.eqSize
    let result = false
    for (const eq of job.seaEQ) {
      if (getConversionValue(eqType) === getConversionValue(eq.eqType) && ((eqSize === eq.eqSize) || StrUtils.isEmpty(eqSize)) ||
        eqSize === eq.eqSize && StrUtils.isEmpty(eqType)) { result = true }
    }
    return result
  }

  /**
   * 计费单位是否是箱子(费用方案)
   */
  static measureIsEq(type) {
    let flag = false
    switch (type) {
      case ChargeMeasure.BY_CNTR_CHARGE_MEASURE.code:
        flag = true
        break
    }
    return flag
  }

  /**
   * @private
   */
  static async chargeItemChange(charge, job) {
    const c = getObjectByCache(basicCacheKeys.basic_data_ChargeItem, 'itemId', Number(charge.chargeItemId))
    if (c) {
      const localCurrency = RateUtil.localCurrencyByOfficeId(charge.branchId)
      // Currency
      const itemCurrency = charge.receivable ? c.defaultarcurrency : c.defaultapcurrency
      if (itemCurrency && itemCurrency !== '') {
        charge.currency = itemCurrency
        charge.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, charge.currency, job, charge.branchId)
      }
      // 垫付写死为RMB
      if (!charge.receivable) {
        charge.currency = localCurrency
        charge.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, charge.currency, job, charge.branchId)
      }

      charge.measure = c.measure

      if (isNaN(charge.unitRate) || charge.unitRate === 0) {
        if (charge.receivable) { charge.unitRate = c.defaultarprice } else { charge.unitRate = c.defaultapprice }
      }
      // CARGO-31314 切换收费项目需要切换对应默认价格
      if (charge.receivable) {
        charge.unitRate = c.defaultarprice
      } else {
        charge.unitRate = c.defaultapprice
      }

      // 默认结算对象
      const code = charge.receivable ? c.defaultArCode : c.defaultApCode
      if (code === ChargeItemTarget.WTDW.code) { // 委托单位
        charge.accountId = job.customerId
      } else if (code === ChargeItemTarget.DCDW.code) { // 订舱代理
        charge.accountId = job.bookingAgent
      } else if (code === ChargeItemTarget.MTGS.code) { // 码头公司
        if (job.lob === 'SE') {
          charge.accountId = job.terminalCompany
        }
      } else if (code === ChargeItemTarget.CAG.code) { // 船代
        charge.accountId = job.carrierAgentId
      } else if (code === ChargeItemTarget.CYR.code) { // 承运人
        charge.accountId = job.carrierId
      } else if (code === ChargeItemTarget.HYDL.code) { // 海外代理
        charge.accountId = job.destinationAgent
      } else if (code === ChargeItemTarget.FYDL.code) { // 发运代理
        if (job.lob === 'RE' || job.lob === 'RI') {
          charge.accountId = new RailwayExportJob(job).forwardingAgent
        }
      } else if (code === ChargeItemTarget.BGH.code) { // 报关行
        charge.accountId = job.customsBroker
      } else if (code === ChargeItemTarget.CD.code) { // 车队
        charge.accountId = job.carryingCmp
      } else if (code === ChargeItemTarget.CK.code) { // 仓库
        charge.accountId = job.warehouseCmp
      } else if (code === ChargeItemTarget.FHR.code) { // 发货人
        charge.accountId = job.shipperId
      } else if (code === ChargeItemTarget.SHR.code) { // 收货人
        charge.accountId = job.consigneeId
      } else if (code === ChargeItemTarget.TZR.code) { // 通知人
        charge.accountId = job.notifyId
      } else { // 没有维护的结算对象为空
        charge.accountId = 0
      }
      const company = await Company.getCompanyById(charge.accountId)
      if (company) {
        charge.oversea = (company.designationAgent || company.overseaAgent)
      }
      charge.serviceType = c.serviceType
    }
    return c
  }
  /**
   * 是否有空费用
   */
  static checkHasEmptyCharge(charges, tabName) {
    const index = this.eachFilter(charges, function(item) {
      const charge = item
      return charge && (charge.chargeItemId === 0 || !charge.chargeItemId)
    })
    if (index > -1) {
      // this.alert(ResourceManager.getInstance().getString('Message','PleaseEnterTheBillingObject'), grid, index, columnIndex);
      throw new TabError(lang.t('Message.PleaseEnterTheNameOfTheCosts'), tabName)
    }
    return index === -1
  }

  /**
   * 是否有空费用
   */
  static checkHasEmptyAccount(charges, tabName) {
    const index = this.eachFilter(charges, function(item) {
      const charge = item
      return charge && (charge.accountId === 0 || !charge.accountId)
    })
    if (index > -1) {
      throw new TabError(lang.t('Message.PleaseEnterTheBillingObject'), tabName)
      // alert(ResourceManager.getInstance().getString('Message','PleaseEnterTheBillingObject'), grid, index, columnIndex);
    }
    return index === -1
  }

  /**
   * 是否有空数量
   */
  static checkHasEmptyQuantity(charges, tabName) {
    const index = this.eachFilter(charges, function(item) {
      const charge = item
      return charge && (!charge.quantity || isNaN(charge.quantity) || charge.quantity === 0)
    })
    if (index > -1) {
      throw new TabError(lang.t('Message.PleaseEnterTheQuantityOfTheCosts'), tabName)
      // alert(ResourceManager.getInstance().getString('Message','PleaseEnterTheQuantityOfTheCosts'), grid, index, columnIndex);
    }
    return index === -1
  }

  /**
   * 是否有空的单价
   */
  static checkHasEmptyPrice(charges, tabName) {
    const index = this.eachFilter(charges, function(item) {
      const charge = item
      return charge && (!charge.quantity || isNaN(charge.unitRate) || charge.unitRate === 0)
    })
    if (index > -1) {
      throw new TabError(lang.t('Message.PleaseEnterThePriceOfTheCosts'), tabName)
      // alert(ResourceManager.getInstance().getString('Message','PleaseEnterThePriceOfTheCosts'), grid, index, columnIndex);
    }
    return index === -1
  }

  /**
   * 循环数组确认是否满足filterFunction，如果满足则返回索引。
   */
  static eachFilter(dataSource, filterFunction) {
    let index = -1
    const len = !dataSource ? 0 : dataSource.length
    for (let i = 0; i < len; i++) {
      if (filterFunction(dataSource[i])) {
        index = i
        break
      }
    }
    return index
  }

  /**
   * common alert
   */
  // static alert(text, grid:DataGrid, row, col)
  // {
  //   MessageDialog.info(text, ResourceManager.getInstance().getString('Message','Prompt'), null, function(event:CloseEvent)
  //   {
  //     grid.callLater(function()
  //     {
  //       grid.startItemEditorSession(row, col);
  //     });
  //   });
  // }

  static getCargoType(lob) {
    switch (lob) {
      case 'SE':
        return CARGO_TYPE_SE
      case 'SI':
        return CARGO_TYPE_SI
      case 'AE':
        return AirExportConstants.BUSINESS_MODELS
      case 'AI':
        return CARGO_TYPE_AI
      case 'IE':
        return ContainerLoadType.IE_TYPES
    }
    return null
  }

  /**
   * 获取费用项目默认的结算对象
   */
  static getChargeDefaultChargeItem(job, defaultCode) {
    let accountId = 0
    switch (defaultCode) {
      case ChargeItemTarget.WTDW.code : // 委托单位
        accountId = job.customerId
        break

      case ChargeItemTarget.DCDW.code : // 订舱代理
        accountId = job.bookingAgent
        break
      case ChargeItemTarget.MTGS.code : // 码头公司
        if (job.lob === 'SE') {
          accountId = job.terminalCompany
        }
        break

      case ChargeItemTarget.CAG.code : // 船代
        accountId = job.carrierAgentId
        break

      case ChargeItemTarget.CYR.code : // 承运人
        accountId = job.carrierId
        break

      case ChargeItemTarget.BGH.code : // 报关行
        accountId = job.customsBroker
        break

      case ChargeItemTarget.HYDL.code : // 海外代理
        if (job.lob === 'AI') {
          accountId = new AirImportJob(job).loadingAgentId
        } else {
          accountId = job.destinationAgent
        }
        break
      case ChargeItemTarget.FYDL.code : // 发运代理
        if (job.lob === 'RE' || job.lob === 'RI') {
          accountId = new RailwayExportJob(job).forwardingAgent
        }
        break
      case ChargeItemTarget.CK.code : // 仓库
        if (job.warehouseInfo && job.warehouseInfo.length > 0) {
          accountId = job.warehouseInfo[0].warehouseCmp
        }
        break

      case ChargeItemTarget.CD.code : // 车队
        if (job.trucking && job.trucking.length > 0) {
          for (const trucking of job.trucking) {
            if (trucking.truckingId !== 0) {
              accountId = trucking.carryingCmp
              break
            }
          }
        }
        break

      case ChargeItemTarget.FHR.code : // 发货人
        accountId = job.shipperId
        break
      case ChargeItemTarget.SHR.code : // 收货人
        accountId = job.consigneeId
        break
      case ChargeItemTarget.TZR.code : // 通知人
        accountId = job.notifyId
        break

      default : break
    }
    return accountId
  }

  /**
   *  国内国外
   *  必须是没有做过核销的才允许修改国内国外
   * <strong>受</strong>基础配置的canChangeOverseaOfCharge配置项控制
   * canChangeOverseaOfCharge = 0 会自动刷新国内外,手动修改费用国内外将会无效
   * canChangeOverseaOfCharge = 1 只能手动修改费用国内外
   */
  static async getChargeisOversea(charge) {
    if (parseInt(cache.config.get('canChangeOverseaOfCharge')) === 0) {
      await this.getChargeisOverseaNotControlledByConfig(charge)
    }
  }

  /**
   *  国内国外更新,必须是没有做过核销的才允许修改国内国外
   * <strong>不受</strong>基础配置的canChangeOverseaOfCharge配置项控制
   */
  static async getChargeisOverseaNotControlledByConfig(charge) {
    await cache.load(cacheName.CONFIG)
    const company = await Company.getCompanyById(charge.accountId)
    // 必须是没有做过结算的才允许修改国内国外
    if (company && !this.isSettled(charge)) {
      const canChangeOverseaOfCharge = parseInt(cache.config.get('canChangeOverseaOfCharge'))
      if (canChangeOverseaOfCharge === 2) {
        charge.oversea = false
      } else if (canChangeOverseaOfCharge === 3) {
        charge.oversea = true
      } else {
        charge.oversea = (company.designationAgent || company.overseaAgent)
      }
      if (charge.oversea && charge.receivable) {
        charge.taxRate = 0
      }
    }
  }
  /**
   *  国内国外更新,必须是没有做过核销的才允许修改国内国外（不修改税率）
   * <strong>不受</strong>基础配置的canChangeOverseaOfCharge配置项控制
   */
  static async getChargeisOverseaNotControlledByConfigIgnoreTaxRate(charge) {
    await cache.load(cacheName.CONFIG)
    const company = await Company.getCompanyById(charge.accountId)
    // 必须是没有做过结算的才允许修改国内国外
    if (company && !this.isSettled(charge)) {
      const canChangeOverseaOfCharge = parseInt(cache.config.get('canChangeOverseaOfCharge'))
      if (canChangeOverseaOfCharge === 2) {
        charge.oversea = false
      } else if (canChangeOverseaOfCharge === 3) {
        charge.oversea = true
      } else {
        charge.oversea = (company.designationAgent || company.overseaAgent)
      }
    }
  }
  // 费用根据配置带出国内外
  static async getChargeOverseaByConfig(charge) {
    await cache.load(cacheName.CONFIG)
    const canChangeOverseaOfCharge = parseInt(cache.config.get('canChangeOverseaOfCharge'))
    if (canChangeOverseaOfCharge === 2) {
      charge.oversea = false
    } else if (canChangeOverseaOfCharge === 3) {
      charge.oversea = true
    } else {
      const company = await Company.getCompanyById(charge.accountId)
      if (company) {
        charge.oversea = (company.designationAgent || company.overseaAgent)
      }
    }
  }
  //
  /**
   * 是否已经做过结算
   * true:已做过结算,false:未做过结算
   * @param charge
   * @return
   */
  static isSettled(charge) {
    if (!charge) return false
    return !(!charge.billingUuid && !charge.billingPaymentUuid && !charge.invoiceUuid && !charge.paidOff && Number(charge.verifiedAmount) === 0)
  }

  /**
   * 复制费用方案
   */
  static copyChargeScheme(target) {
    const lob = LocalStorageUtilsNew.getConfiguration('COPY_LOB_COST_PLAN')
    const name = LocalStorageUtilsNew.getConfiguration('COPY_NAME_COST_PLAN')
    const cargoType = LocalStorageUtilsNew.getConfiguration('COPY_CARGO_TYPE_COST_PLAN')
    const remark = LocalStorageUtilsNew.getConfiguration('COPY_REMARK_COST_PLAN')
    const effectiveDate = LocalStorageUtilsNew.getConfiguration('COPY_EFFECTIVE_DATE_COST_PLAN')
    const expiryDate = LocalStorageUtilsNew.getConfiguration('COPY_EXPIRY_DATE_COST_PLAN')
    const department = LocalStorageUtilsNew.getConfiguration('COPY_DEPARTMENT_COST_PLAN')
    const containerLoadType = LocalStorageUtilsNew.getConfiguration('COPY_CONTAINER_LOAD_TYPE_COST_PLAN')
    const chargeDetail = LocalStorageUtilsNew.getConfiguration('COPY_CHARGE_DETAIL_COST_PLAN')
    const scheme = {}
    if (lob) {
      scheme.lob = target.lob
    }
    if (name) {
      scheme.name = target.name
    }
    if (cargoType) {
      scheme.cargoType = target.cargoType
    }
    if (remark) {
      scheme.remark = target.remark
    }
    if (effectiveDate) {
      scheme.effectiveDate = target.effectiveDate
    }
    if (expiryDate) {
      scheme.expiryDate = target.expiryDate
    }
    if (department) {
      scheme.departmentIdArr = target.departmentIdArr
    }
    if (containerLoadType) {
      scheme.containerLoadTypeArr = target.containerLoadTypeArr
    }
    scheme.customerId = target.customerId
    scheme.carrierId = target.carrierId
    scheme.bookingAgent = target.bookingAgent
    scheme.containerLoadType = target.containerLoadType
    scheme.region = target.region
    scheme.inputByDep = target.inputByDep
    scheme.branchId = target.branchId
    scheme.inputBy = target.inputBy
    scheme.inputDate = new Date()
    const newDetail = []
    if (chargeDetail) {
      for (const oldDetail of target.schemeDetail) {
        const detail = {}
        detail.level = oldDetail.level
        detail.amount = oldDetail.amount
        detail.receivable = oldDetail.receivable
        detail.rangeGe = oldDetail.rangeGe
        detail.rangeLt = oldDetail.rangeLt
        detail.minimum = oldDetail.minimum
        detail.rangeFrom = oldDetail.rangeFrom
        detail.rangeTo = oldDetail.rangeTo
        detail.unitStep = oldDetail.unitStep
        detail.taxRate = oldDetail.taxRate
        detail.unitPriceIncludeTax = oldDetail.unitPriceIncludeTax
        detail.cityCode = oldDetail.cityCode
        detail.chargeItemId = oldDetail.chargeItemId
        detail.partnerType = oldDetail.partnerType
        detail.accountId = oldDetail.accountId
        detail.currency = oldDetail.currency
        detail.measure = oldDetail.measure
        detail.unitRate = oldDetail.unitRate
        detail.eqSize = oldDetail.eqSize
        detail.eqType = oldDetail.eqType
        detail.quantity = oldDetail.quantity
        detail.remark = oldDetail.remark
        detail.needInvoice = oldDetail.needInvoice
        detail.waitDealStatus = 'add'
        newDetail.push(detail)
      }
    }
    scheme.schemeDetail = newDetail
    return scheme
  }

  /**
   * 复制费用
   */
  static copyCharge(charge, user, department, office) {
    const c = new Charge().fillDefaultValue().getData()
    c.inputBy = user == null ? 0 : user.userId
    c.inputDate = new Date()
    c.inputByDep = department == null ? 0 : department.departmentId
    c.branchId = office == null ? 0 : office.officeId
    const localCurrency = RateUtil.localCurrencyByOfficeId(c.branchId)
    c.localCurrency = localCurrency
    c.oversea = charge.oversea
    c.receivable = charge.receivable
    c.currency = charge.currency
    c.exchangeRate = charge.exchangeRate
    c.chargeItemId = charge.chargeItemId
    c.accountId = charge.accountId
    c.measure = charge.measure
    c.quantity = charge.quantity
    c.unitRate = charge.unitRate
    c.amount = charge.amount
    c.excludingTaxAmount = charge.excludingTaxAmount
    c.taxRate = charge.taxRate
    c.taxAmount = charge.taxAmount
    c.remarks = charge.remarks
    c.partnerType = charge.partnerType
    c.controlled = charge.controlled
    c.unitPriceIncludeTax = charge.unitPriceIncludeTax
    return c
  }

  // /**
  //  * 按币种，确认状态，业务进行分组
  //  */
  // static getGroupByChargeJobs(charges,isAr)
  // {
  //   const jobCurreny:Object = {};
  //   const jobList = new Set;
  //   const job:Job = null;
  //   for each(const charge in charges)
  //   {
  //     const key = (charge.currency+charge.confirmState+charge.receivable+charge.job.key);
  //     if(!jobCurreny.hasOwnProperty(key))
  //     {
  //       job = ObjectUtil.clone(charge.job) as Job;
  //       job.billingAmount = charge.billingAmount;
  //       job.chargeAmountTotal = charge.amount;
  //       job.isAr = charge.receivable;
  //       job.chargeCurrency = charge.currency;
  //       job.confirmState = charge.confirmState;
  //       job.differenceAmount = getRoundingValue(job.chargeAmountTotal - charge.billingAmount);
  //       job.charges = new Set();
  //       job.charges.addItem(charge);
  //       jobCurreny[key] = job;
  //       jobList.addItem(job);
  //     }
  //     else
  //     {
  //       job = jobCurreny[key];
  //       if(job)
  //       {
  //         job.billingAmount += charge.billingAmount;
  //         job.charges.addItem(charge);
  //         job.chargeAmountTotal += charge.amount;
  //         job.differenceAmount = getRoundingValue(job.chargeAmountTotal - job.billingAmount);
  //       }
  //     }
  //   }
  //   return jobList;
  // }
  //
  // /**
  //  * 获取应收应付金额
  //  */
  // static getArChargeAmount(charge,isAr)
  // {
  //   if(isAr)
  //   {
  //     return (charge.receivable ? charge.amount : -charge.amount);
  //   }
  //   else
  //   {
  //     return (charge.receivable ? -charge.amount : charge.amount);
  //   }
  // }

  /**
   * 获取服务项目默认费用项
   */
  static getServiceDefaultChargeItem(job) {
    const result = new Set()
    const items = getCacheListByKey(basicCacheKeys.basic_data_ChargeItem)
    for (const chargeItem of items) {
      if (chargeItem.serviceType > 0 && chargeItem.defaultChargeItem) {
        if (chargeItem.serviceType === ChargeServiceTypeItem.CHARGE_SERVICE_CUSTOMS.code) {
          if (job.lob === 'SE' && new SeaExportJob(job).customs) {
            result.add(chargeItem)
          } else if (job.lob === 'SI' && new SeaImportJob(job).customs) {
            result.add(chargeItem)
          } else if (job.lob === 'AI' && new AirImportJob(job).customs) {
            result.add(chargeItem)
          }
        } else if (chargeItem.serviceType === ChargeServiceTypeItem.CHARGE_SERVICE_WAREHOUSING.code && job.warehousing) {
          result.add(chargeItem)
        } else if (chargeItem.serviceType === ChargeServiceTypeItem.CHARGE_SERVICE_CARRYING.code && job.landTransportation) {
          result.add(chargeItem)
        } else if (chargeItem.serviceType === ChargeServiceTypeItem.CHARGE_SERVICE_BOOKING.code) {
          result.add(chargeItem)
        }
      }
    }
    return result
  }

  /**
   * 服务项目应收费用
   */
  static async getServiceDefaultCostCharge(job, chargeBranchId = 0) {
    const result = new Set()
    const items = this.getServiceDefaultChargeItem(job)
    const branchId = chargeBranchId || job.opOffice
    const localCurrency = RateUtil.localCurrencyByOfficeId(branchId)
    for (const chargeItem of items) {
      const charge = new Charge().fillDefaultValue().getData()
      charge.jobUuid = job.uuid
      charge.businessDate = job.businessDate
      charge.serviceType = chargeItem.serviceType
      charge.chargeItemId = chargeItem.itemId
      charge.accountId = job.customerId
      const company = await Company.getCompanyById(charge.accountId)
      if (company) {
        charge.oversea = (company.designationAgent || company.overseaAgent)
      }
      charge.currency = chargeItem.defaultarcurrency
      charge.localCurrency = localCurrency
      charge.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, charge.currency, job, branchId)
      charge.inputBy = $store.getters.userId
      charge.inputDate = new Date()
      charge.inputByDep = job.opDepartment
      charge.branchId = branchId
      charge.quantity = 1
      charge.unitRate = chargeItem.defaultarprice
      charge.receivable = true
      ChargeUtils.calculateTax(charge, charge.quantity * charge.unitRate, charge.taxRate)
      const office = $store.getters.currentOffice
      if (office && String(office.taxRate) !== 'NaN') {
        charge.taxRate = office.taxRate
      } else {
        charge.taxRate = 0
      }
      ChargeUtils.calculateTax(charge, charge.quantity * charge.unitRate, charge.taxRate)
      result.add(charge)
    }
    return this.sortChargeServiceType([...result])
  }

  /**
   * 服务项目应付费用
   */
  static async getServiceDefaultSellingCharge(job, chargeBranchId = 0) {
    const result = new Set()
    const items = this.getServiceDefaultChargeItem(job)
    const branchId = chargeBranchId || job.opOffice
    const localCurrency = RateUtil.localCurrencyByOfficeId(branchId)
    for (const chargeItem of items) {
      const charge = new Charge().fillDefaultValue().getData()
      charge.jobUuid = job.uuid
      charge.businessDate = job.businessDate
      charge.serviceType = chargeItem.serviceType
      charge.chargeItemId = chargeItem.itemId
      charge.accountId = job.bookingAgent
      await this.getChargeisOversea(charge)
      charge.currency = chargeItem.defaultapcurrency
      charge.localCurrency = localCurrency
      charge.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, charge.currency, job, branchId)
      charge.inputBy = $store.getters.userId
      charge.inputDate = new Date()
      charge.inputByDep = job.opDepartment
      charge.branchId = branchId
      charge.quantity = 1
      charge.unitRate = chargeItem.defaultapprice
      charge.receivable = false
      ChargeUtils.calculateTax(charge, charge.quantity * charge.unitRate, charge.taxRate)
      result.add(charge)
    }
    return this.sortChargeServiceType([...result])
  }

  /**
   * 根据服务项目过滤结算单位
   * 订舱-订舱代理、客户、代理
   * 报关-报关行、客户、代理
   * 仓储-仓库、客户、代理
   * 运输-车队、客户、代理
   * 其它-客户、客户、代理
   */
  static getServiceAccountDataFilter(charge, company) {
    const c = company
    if (!charge || !c) { return false }

    if (!c.active || charge.serviceType === 0) { return false }

    if (c.customer || c.designationAgent || c.overseaAgent || c.settlementAgent || c.localAgent) { return true }

    if (charge.serviceType === ChargeServiceTypeItem.CHARGE_SERVICE_BOOKING.code && c.bookingAgent) {
      return true
    } else if (charge.serviceType === ChargeServiceTypeItem.CHARGE_SERVICE_CUSTOMS.code && c.bookingAgent) {
      return true
    } else if (charge.serviceType === ChargeServiceTypeItem.CHARGE_SERVICE_WAREHOUSING.code && c.warehouse) {
      return true
    } else if (charge.serviceType === ChargeServiceTypeItem.CHARGE_SERVICE_CARRYING.code && c.truckCmp) {
      return true
    } else if (charge.serviceType === ChargeServiceTypeItem.CHARGE_SERVICE_OTHER.code && c.other) {
      return true
    }
    return false
  }

  /**
   * 取委托单位和关联工厂
   */
  static async getCompanyFactorySign(cmpIdx) {
    if (!cmpIdx) {
      return []
    }
    const company = await Company.getCompanyById(cmpIdx)
    let companyFactorySigns = await new Company(company).getCompanyFactorySign()
    if (!companyFactorySigns) {
      companyFactorySigns = []
    }
    const list = []
    for (const id of companyFactorySigns) {
      const c = await Company.getCompanyById(id.factorySignCmpIdx)
      if (c) {
        // 添加对应工厂数据
        list.push(c)
      }
    }
    // 这里包含了委托单位
    list.push(company)
    return list
  }

  static checkFactorySign(companyFactorySigns, cmpIdx) {
    if (!companyFactorySigns) {
      return false
    }
    const factory = companyFactorySigns.filter(p => p.cmpIdx === cmpIdx)
    if (factory && factory.length > 0) {
      return true
    }
    return false
  }
  /**
   * 按服务项目进行排序
   */
  static sortChargeServiceType(collection) {
    return sortByMultiField(collection, ['serviceType'], false)
  }

  // /**
  //  * 创建装箱费
  //  */
  // static createPackingCharge(job:Job)
  // {
  //   const charge = new Charge();
  //   charge.job = job;
  //   charge.businessDate = job.businessDate;
  //   charge.quantity = 1;
  //   charge.currency = "RMB";
  //   charge.exchangeRate = RateUtil.getForeignExchangeRateByJob("RMB", charge.currency, job);
  //   charge.measure = "NML";
  //   charge.receivable = false;
  //   charge.oversea = false;
  //   charge.verifiedAmount = 0;
  //   charge.inputDate = new Date();
  //   charge.inputBy = Session.getInstance().user.userId;
  //   charge.branchId = Session.getInstance().currentOffice.officeId;
  //   return charge;
  // }
  //
  /**
   * 对原费用列表进行排序，返回一个排序后的新数据源
   */
  static sortCharges(dataSource) {
    // 老系统原来就是屏蔽的
    // for (const charge of dataSource) {
    //   // 序号，CARGO-5881，按照录入顺序排序
    //   //				const chargeItem:ChargeItem = ChargeItem.getChargeItemById(charge.chargeItemId);
    //   //				charge.serialNumber = chargeItem == null ? 99 : chargeItem.serialNumber;
    // }
    return sortByMultiField(dataSource, ['serialNumber', 'chargeId'], false)
  }

  static sortCharges2(dataSource, collation) {
    // return sortByMultiFieldAndOrder(dataSource, { jobNo: 'asc', fileName: 'asc', fileVersion: 'desc', createDate: 'desc' })
    return sortByMultiFieldAndOrder(dataSource, collation)
  }
  /**
   * 收集小票
   */
  static async groupingSlaveChargeAccountId(slaves, isAr) {
    const accountIds = new Set()
    for (const job of slaves) {
      // await job.getCharges()
      const res = await getChargeList(job.uuid)
      job.charges = res.data
      if (job.charges && job.charges.length > 0) {
        for (const charge of job.charges) {
          if (charge.receivable === isAr && !accountIds.has(charge.accountId)) {
            accountIds.add(charge.accountId)
          }
        }
      }
    }
    return accountIds
  }

  /**
   * 把小票成本抄录到主票应收上
   */
  static async copySlaveCostToMaster(masterJob, accountIds, isAr, uuidPrefixRule) {
    const allCharge = new Set()
    await masterJob.getLclSlaves()
    for (const job of masterJob.lclSlaves) {
      // await job.getCharges()
      const res = await getChargeList(job.uuid)
      job.charges = res.data
      if (job.charges && job.charges.length > 0) {
        for (const charge of job.charges) {
          allCharge.add(charge)
        }
      }
    }
    const charges = this.groupingByAccountIdCurrency(allCharge, isAr, accountIds, uuidPrefixRule)
    for (const charge of charges) {
      charge.jobUuid = masterJob.uuid
    }
    return charges
  }

  /**
   * 按结算单位，币种分组费用。
   */
  static groupingByAccountIdCurrency(charges, isAr, accountIds, uuidPrefixRule) {
    const list = new Set()
    for (const charge of charges) {
      if (charge.receivable === isAr && accountIds.includes(charge.accountId)) {
        let filterCharge = this.filterCharge(list, charge.accountId, charge.chargeItemId, charge.currency)
        if (filterCharge === null) {
          filterCharge = {}
          filterCharge.uuid = uuidPrefixRule + getUuid()
          filterCharge.receivable = !isAr
          filterCharge.accountId = charge.accountId
          filterCharge.chargeItemId = charge.chargeItemId
          filterCharge.quantity = 1
          filterCharge.measure = ChargeMeasure.SHIPMENT_CHARGE_MEASURE.code
          filterCharge.unitRate = charge.amount
          filterCharge.amount = charge.amount
          filterCharge.excludingTaxAmount = charge.amount
          filterCharge.isOversea = charge.isOversea
          filterCharge.currency = charge.currency
          const localCurrency = RateUtil.localCurrencyByOfficeId(charge.branchId)
          filterCharge.exchangeRate = RateUtil.getForeignExchangeRateSafely(charge.currency, localCurrency, new Date(), charge.branchId)
          list.add(filterCharge)
        } else {
          filterCharge.amount += charge.amount
          filterCharge.unitRate += charge.amount
          filterCharge.excludingTaxAmount += charge.amount
        }
      }
    }
    return list
  }

  /**
   * 根据费用类型和币种查询汇率
   */
  static filterCharge(charges, accountId, chargeItemId, currency) {
    let c = null
    for (const charge of charges) {
      if (charge.chargeItemId === chargeItemId && charge.accountId === accountId && charge.currency === currency) {
        c = charge
        break
      }
    }
    return c
  }

  // /**
  //  *
  //  * 列表上显示开票方式解析
  //  */
  // static invoiceModeShow(wapper:Object)
  // {
  //   const charges = wapper.results;
  //   if(charges)
  //   {
  //     const otherResult:Object = wapper.otherResult;
  //     if(otherResult && otherResult["invoiceMode"])
  //     {
  //       const invoiceModeObj:Object = otherResult["invoiceMode"];
  //       if(invoiceModeObj)
  //       {
  //         for each (const c in charges)
  //         {
  //           if (invoiceModeObj[c.key] == 0 || invoiceModeObj[c.key] == 1)
  //             c.cdInvoiceMode = invoiceModeObj[c.key];
  //         }
  //       }
  //     }
  //   }
  // }
  //
  // /**
  //  *
  //  * 列表上显示开票方式解析
  //  */
  // static billingGroupShow(wapper:Object)
  // {
  //   const charges = wapper.results;
  //   if(charges)
  //   {
  //     const otherResult:Object = wapper.otherResult;
  //     if(otherResult && otherResult["billingGroup"])
  //     {
  //       const billingGroupObj:Object = otherResult["billingGroup"];
  //       if(billingGroupObj)
  //       {
  //         for each (const c in charges)
  //         {
  //           if(billingGroupObj.hasOwnProperty(c.key))
  //           {
  //             c.billingGroupNo = billingGroupObj[c.key];
  //           }
  //         }
  //       }
  //     }
  //   }
  // }

  /**
   * 核销状态
   */
  static calcIsVerification(wapper) {
    const jobs = wapper.results.list
    if (jobs) {
      const otherResult = wapper.otherResult
      if (otherResult && otherResult['receivable']) { // 应收
        const receivableMap = otherResult['receivable']
        if (receivableMap) {
          for (const job of jobs) {
            if (receivableMap[job.uuid]) { job.receivable = receivableMap[job.uuid] } else { job.receivable = '无应收' }
          }
        }
      }

      if (otherResult && otherResult['due']) { // 应付
        const dueMap = otherResult['due']
        if (dueMap) {
          for (const j of jobs) {
            if (dueMap[j.uuid]) { j.due = dueMap[j.uuid] } else { j.due = '无应付' }
          }
        }
      }
    }
  }

  // /**
  //  * 将数据进行四舍五入,四舍五入的方式按照ToFixed方法,
  //  * digits控制的是数据的有效位数
  //  * 数据的整数位长度大于或等于digits则直接返回整数部分
  //  * 数据的整数位长度与小数位长度大于digits则进行四舍五入
  //  * 数据的整数位长度与小数位长度小余digits则小数位填零处理
  //  * 数据长度等于digits则不进行处理返回
  //  * @param value
  //  * @param digits
  //  * @return
  //  *
  //  * 注意: CARGO-6672，计算得到 0.061782（也是发票汇率），ChargeUtils.toFixByDigitLength 折算后，0.061780
  //  */
  // static toFixByDigitLength(value, digits) {
  //   const outValueString = "0";
  //   const str = value.toString();
  //   const isNegative;
  //   if(str.indexOf("-") > -1) {
  //     str = Math.abs(value).toString();
  //     isNegative = true;
  //   }
  //   const index = str.indexOf(".");
  //   const strInt = str;
  //   const strDec = "";
  //   if(index>0)
  //   {
  //     strInt = str.substr(0, index);
  //     strDec = str.substr(index+1, digits);
  //   }
  //   //整数位数大于或等于数据位
  //   if (strInt.length >= digits)
  //     outValueString = strInt;
  //     //整数位与小数位总长大于或等于数据位
  //   else if (strInt.length + strDec.length >= digits) {
  //     outValueString = this.ToFixed(isNegative ? -value:value, digits - strInt.length);
  //   }else {
  //     //整数位与小数位总长小余数据位
  //     while((strDec.length + strInt.length)< digits)
  //     {
  //       strDec += "0";
  //     }
  //     const val = parseFloat(strInt+ "." +strDec);
  //     outValueString = this.ToFixed(val, digits);
  //   }
  //   return isNegative ? "-" + outValueString : outValueString;
  // }
  //
  /**
   * 统计箱量2
   */
  static getEQQuantity2(type, job, seaEQ = null) {
    if (seaEQ) { return seaEQ.eqQuantity }
    let n = 0
    if (job != null && job.seaEQ != null) {
      for (const eq of job.seaEQ) {
        if (type === 'C20' && eq.EQsize === '20') { n = n + eq.eqQuantity } else if (type === 'C40' && eq.eqSize === '40' && eq.eqType === 'GP') { n = n + eq.eqQuantity } else if (type === 'C40H' && eq.eqSize === '40' && eq.eqType === 'HC') { n = n + eq.eqQuantity } else if (type === 'C45' && eq.eqSize === '45') { n = n + eq.eqQuantity }
      }
    }
    return n
  }

  // static isC(billing:Billing) {
  //   const c = false;
  //   for each(const charge2 in billing.charge) {
  //     if (charge2.isControlled) {
  //       c = true;
  //     }
  //   }
  //   return c;
  // }
  //
  /**
  * etd 更新费用汇率
  */
  static async updateETDFee(job, etd, context, isRenew = false) {
    let dateValue = null
    if (etd) {
      dateValue = etd
    }
    if (dateValue) {
      if (!job.charges) return
      let isFlag = false
      const charges = []
      const receiptCharges = []
      let jobCharges = job.charges
      let prompt = true
      let confirm = false // 主票更新标志
      let currencys = []
      // 是否主票
      const isMaster = job.masterFlag
      const useLocalCurrency = RateUtil.useLocalCurrency()
      const hqCurrencyMap = new Map()
      const hqRateMap = new Map()
      const onCancelCallback = async(index) => {
        prompt = false
        if (index === 1 || index === 2) {
          for (const c of jobCharges) {
            // 费用锁定时不更新汇率
            if (this.checkLock(job.receivableChargeLockedStatus, job.payableChargeLockedStatus, c.receivable)) {
              // 只有可以编辑的才能修改，排除无权限编辑情况
              if (this.chargeEditing(c, job)) {
                // 只有汇率不同时才更新
                const localCurrency = RateUtil.localCurrencyByOfficeId(c.branchId)
                const rate = await RateUtil.getForeignExchangeRateByDate(localCurrency, c.currency, dateValue, c.branchId, null, false)
                const hqRate = await ChargeUtils.getHqRate2UpdateETDFee(c.branchId, hqRateMap, hqCurrencyMap, dateValue, localCurrency)
                const hqCurrency = hqCurrencyMap.get(c.branchId)
                if (rate > 0 && NumberUtils.roundHalfUp(rate, 8) !== c.exchangeRate) {
                  c.exchangeRate = NumberUtils.roundHalfUp(rate, 8)
                  // HQ币种/汇率
                  c.hqCurrency = hqCurrency
                  c.hqRate = hqRate
                  charges.push(c)
                  currencys.push(c.currency)
                } else if (useLocalCurrency && NumberUtils.roundHalfUp(hqRate, 8) !== c.hqRate) {
                  c.hqCurrency = hqCurrency
                  c.hqRate = hqRate
                  charges.push(c)
                }
              }
            }
          }
          if (charges.length > 0) {
            context.modifiedData.charges = context.modifiedData.charges || []
            mergeArray(context.modifiedData.charges, charges) // 只记住修改过的数据
            context.reloadCharge = true
          }
        }
        if (index === 1) {
          for (const l of job.lclSlaves) {
            if (!l.receivableChargeLockedStatus || !l.payableChargeLockedStatus) {
              for (const c of l.charges) {
                // 费用锁定时不更新汇率
                if (this.checkLock(l.receivableChargeLockedStatus, l.payableChargeLockedStatus, c.receivable)) {
                  if (this.chargeEditing(c, l)) {
                    // 只有汇率不同时才更新
                    const localCurrency = RateUtil.localCurrencyByOfficeId(c.branchId)
                    const rate = await RateUtil.getForeignExchangeRateByDate(localCurrency, c.currency, dateValue, c.branchId, null, false)
                    const hqRate = await ChargeUtils.getHqRate2UpdateETDFee(c.branchId, hqRateMap, hqCurrencyMap, dateValue, localCurrency)
                    const hqCurrency = hqCurrencyMap.get(c.branchId)
                    if (rate > 0 && NumberUtils.roundHalfUp(rate, 8) !== c.exchangeRate) {
                      c.exchangeRate = NumberUtils.roundHalfUp(rate, 8)
                      // HQ币种/汇率
                      c.hqCurrency = hqCurrency
                      c.hqRate = hqRate
                      receiptCharges.push(c)
                      currencys.push(c.currency)
                    } else if (useLocalCurrency && NumberUtils.roundHalfUp(hqRate, 8) !== c.hqRate) {
                      c.hqCurrency = hqCurrency
                      c.hqRate = hqRate
                      charges.push(c)
                    }
                  }
                }
              }
            }
          }
          job.receiptCharges = receiptCharges
          context.receiptCharges = receiptCharges
          context.reloadCharge = true
        }
        if (currencys.length > 0) {
          currencys = [...new Set(currencys)]
          Message.success(lang.t('ChangeCharge.updateSuccess', [currencys.join(',')]))
        }
      }
      if (isRenew) {
        // 过滤掉新增的费用
        jobCharges = jobCharges.filter(item => {
          return item.uuid && !item.uuid.startsWith('addTabCost__') && !item.uuid.startsWith('addTabSelling__')
        })
        for (const c of jobCharges) {
          // 只有可以编辑的才能修改，排除无权限编辑情况
          console.log('receivableChargeLockedStatus', job.receivableChargeLockedStatus, c.receivable, job.payableChargeLockedStatus)
          if (this.checkLock(job.receivableChargeLockedStatus, job.payableChargeLockedStatus, c.receivable)) {
            if (this.chargeEditing(c, job)) {
              // 只有汇率不同时才更新
              const localCurrency = RateUtil.localCurrencyByOfficeId(c.branchId)
              const rate = await RateUtil.getForeignExchangeRateByDate(localCurrency, c.currency, dateValue, c.branchId, null, false)
              const hqRate = await ChargeUtils.getHqRate2UpdateETDFee(c.branchId, hqRateMap, hqCurrencyMap, dateValue, localCurrency)
              const hqCurrency = hqCurrencyMap.get(c.branchId)
              if (rate > 0 && NumberUtils.roundHalfUp(rate, 8) !== c.exchangeRate) {
                if (prompt) {
                  if (isMaster) {
                    Vue.prototype.$globalDialog.openDialog(i18n.t('Message.Tip'), i18n.t('ChangeCharge.exchangeRates2'), {
                      button1: i18n.t('Invoice.invoice_confirm'),
                      button2: i18n.t('Invoice.OnlyMaster'),
                      button3: i18n.t('Invoice.invoice_cancel')
                    }, onCancelCallback)
                  } else {
                    await MessageBox.confirm(i18n.t('ChangeCharge.exchangeRates'), i18n.t('Message.Tip'), {
                      confirmButtonText: i18n.t('Invoice.invoice_confirm'),
                      cancelButtonText: i18n.t('Invoice.invoice_cancel'),
                      type: 'warning',
                      dangerouslyUseHTMLString: true
                    }).then(() => {
                      prompt = false
                      confirm = true
                    }).catch(() => {
                      prompt = false
                    })
                  }
                }
                if (confirm) {
                  c.exchangeRate = NumberUtils.roundHalfUp(rate, 8)
                  // HQ币种/汇率
                  c.hqCurrency = hqCurrency
                  c.hqRate = hqRate
                  charges.push(c)
                  currencys.push(c.currency)
                  if (!isFlag) isFlag = true
                }
              } else if (useLocalCurrency && NumberUtils.roundHalfUp(hqRate, 8) !== c.hqRate) {
                c.hqCurrency = hqCurrency
                c.hqRate = hqRate
                charges.push(c)
              }
            }
          }
        }
        if (prompt && job.lclSlaves && job.lclSlaves.length > 0) {
          for (const l of job.lclSlaves) {
            if (!l.receivableChargeLockedStatus || !l.payableChargeLockedStatus) {
              for (const c of l.charges) {
                if (this.checkLock(l.receivableChargeLockedStatus, l.payableChargeLockedStatus, c.receivable)) {
                  if (this.chargeEditing(c, l)) {
                    // 只有汇率不同时才更新
                    const localCurrency = RateUtil.localCurrencyByOfficeId(c.branchId)
                    const rate = await RateUtil.getForeignExchangeRateByDate(localCurrency, c.currency, dateValue, c.branchId, null, false)
                    const hqRate = await ChargeUtils.getHqRate2UpdateETDFee(c.branchId, hqRateMap, hqCurrencyMap, dateValue, localCurrency)
                    const hqCurrency = hqCurrencyMap.get(c.branchId)
                    if (rate > 0 && NumberUtils.roundHalfUp(rate, 8) !== c.exchangeRate) {
                      Vue.prototype.$globalDialog.openDialog(i18n.t('Message.Tip'), i18n.t('ChangeCharge.exchangeRates2'), {
                        button1: i18n.t('Invoice.invoice_confirm'),
                        button2: i18n.t('Invoice.OnlyMaster'),
                        button3: i18n.t('Invoice.invoice_cancel')
                      }, await onCancelCallback)
                    } else if (useLocalCurrency && NumberUtils.roundHalfUp(hqRate, 8) !== c.hqRate) {
                      c.hqCurrency = hqCurrency
                      c.hqRate = hqRate
                      charges.push(c)
                    }
                  }
                }
              }
            }
          }
        }
        if (confirm && currencys.length > 0) {
          currencys = [...new Set(currencys)]
          Message.success(lang.t('ChangeCharge.updateSuccess', [currencys.join(',')]))
        }
      }
      for (const c of job.charges) {
        if (!c.uuid || c.uuid.startsWith('addTabCost__') || c.uuid.startsWith('addTabSelling__')) {
          const localCurrency = RateUtil.localCurrencyByOfficeId(c.branchId)
          const rate = await RateUtil.getForeignExchangeRateByDate(localCurrency, c.currency, dateValue, c.branchId, null, false)
          c.exchangeRate = NumberUtils.roundHalfUp(rate, 8)
          // HQ币种/汇率
          c.hqRate = await ChargeUtils.getHqRate2UpdateETDFee(c.branchId, hqRateMap, hqCurrencyMap, dateValue, localCurrency)
          c.hqCurrency = hqCurrencyMap.get(c.branchId)
          charges.push(c)
          if (!isFlag) isFlag = true
        }
      }
      if (isFlag && charges.length > 0) {
        context.modifiedData.charges = context.modifiedData.charges || []
        mergeArray(context.modifiedData.charges, charges) // 只记住修改过的数据
        context.reloadCharge = true
      }
    }
  }

  // 更新费用汇率-获取HQ汇率
  static async getHqRate2UpdateETDFee(branchId, hqRateMap, hqCurrencyMap, dateValue, localCurrency) {
    // hqCurrency
    const hqCurrency = hqCurrencyMap.has(branchId) ? hqCurrencyMap.get(branchId) : RateUtil.getHqCurrency(branchId)
    if (!hqCurrencyMap.has(branchId)) { hqCurrencyMap.set(branchId, hqCurrency) }
    // hqRate
    const hqRate = !hqCurrency ? 0 : hqRateMap.has(branchId) ? hqRateMap.get(branchId) : await RateUtil.getForeignExchangeRateByDate(hqCurrency, localCurrency, dateValue, branchId, null, false)
    if (!hqRateMap.has(branchId)) { hqRateMap.set(branchId, hqRate) }
    return hqRate
  }

  /**
   * 是否能编辑费用
   */
  static chargeEditing(item, job) {
    const toExoSystemLHEAS = String(cache.config.get('ToExoSystem')) === 'LHEAS'
    const toExoSystemEAS = String(cache.config.get('ToExoSystem')) === 'EAS' // 中床国际EAS
    const toExoSystemYGSH = String(cache.config.get('ToExoSystem')) === 'YGSH' // 阳光速航
    const chargeSyncNeedConfirm = Number(cache.config.get('ChargeSyncNeedConfirm')) === 1
    const company = getCacheListByKey(basicCacheKeys.basic_data_Company).find(p => p.cmpIdx === job.destinationAgent)
    const isCrossTenantSeToSi = company && this.isCrossTenantSEToSI(company, job)
    if (!item || !job || (job.uuid && !item.jobUuid) || item.jobUuid !== job.uuid || item.verifiedAmount !== 0 ||
        item.billingUuid || item.billingPaymentUuid || item.invoiceUuid ||
        item.shared || item.collection || (item.chargeState !== 0 && item.chargeState !== 3) || (toExoSystemLHEAS && Number(item.externalChargeState) === Number(ChargeConstants.EAS_STATE_SYNC.code) && Number(item.chargeState) === 1) ||
        item.confirmState === 1 || item.agentSharedBillingUuid ||
        (toExoSystemEAS && Number(item.externalChargeState) === Number(ChargeConstants.EAS_STATE_APPROVED.code)) ||
        (item.trustFromCharge && isCrossTenantSeToSi) || item.syncConfirmStatus === 1 ||
        (toExoSystemYGSH && Number(item.ltsChargeState) === Number(ChargeConstants.HAS_BEEN_SENT.code)) || !this.internalEnable(item, job) ||
        (chargeSyncNeedConfirm && item.trustFromCharge && item.chargeSource === Number(CHARGE_SOURCE_EXPORT_SYNC_IMPORT.code)) ||
        this.hasGenerateVoucher(item)) {
      return false
    } else {
      return true
    }
  }

  // 内结费用
  static internalEnable(item, job) {
    if (RateUtil.useOrderCenterMode()) {
      if (item.internalFrom) {
        return false
      } else {
        if (item.internalTo) {
          if (job && job.charges) {
            for (const internal of job.charges) {
              if (internal.internal && internal.chargeId === item.internalTo) {
                return !(internal.billingUuid || internal.invoiceUuid || internal.billingPaymentUuid || internal.confirmBillUuid || internal.verifiedAmount !== 0)
              }
            }
          }
        }
      }
      return true
    } else {
      return true
    }
  }

  static isCrossTenantSEToSI(company, _job) {
    if (!(company.relateTenantId > 0 && company.overseaAgent && _job.jobState === SystemConstants.STATE_OPERATING.code) || _job.containerLoadType === 'SPA') {
      return false
    }
    if ((_job.containerLoadType === 'BC' || _job.containerLoadType === 'LCL')) {
      if (_job.masterFlag && _job.lclSlaves.length === 0) { // 主票没有小票
        return false
      }
      if (!_job.masterFlag && !_job.lclMasterUuid) { // 小票没有关联主票
        return false
      }
    }
    return true
  }

  // 是否生成凭证，CARGO-32427 ID：10539 宏真 费用生成凭证后做限制不能删除费用
  static hasGenerateVoucher(item) {
    return item && (item.voucherDate || item.voucherJob || item.voucherBilling || item.voucherInvoice)
  }

  static checkLock(receivableChargeLockedStatus, payableChargeLockedStatus, receivable) {
    if (receivable) {
      return receivableChargeLockedStatus !== 1
    } else {
      return payableChargeLockedStatus !== 1
    }
  }
  /**
   * 设置批量生成费用的默认开票抬头（比如费用方案）
   */
  static async updateDefaultInvoiceTitle(charges) {
    if (!charges || charges.length <= 0) return
    const compKeys = []
    for (const c of charges) {
      const accountId = c.accountId
      if (accountId > 0) {
        c.invoiceTitle = await Company.getCompanyName(accountId)
        if (!compKeys.includes(accountId)) compKeys.push(accountId)
      }
    }
    if (compKeys.length > 0) {
      // 根据结算对象从数据库中取默认开票抬头
      const titles = await getTitleByCmpIdxList(compKeys).then(res => {
        return res.data
      })
      // console.log('开票抬头', titles)
      if (titles && titles.length > 0) {
        const titleMap = new Map()
        for (const title of titles) {
          if (titleMap.has(title.cmpIdx) || !title.title) continue
          titleMap.set(title.cmpIdx, title.title)
        }
        for (const c of charges) {
          const accountId = c.accountId
          if (accountId > 0 && titleMap.get(accountId)) {
            c.invoiceTitle = titleMap.get(accountId)
          }
        }
      }
      // 若从数据库中未取到默认开票抬头，则开票抬头取
      for (const c of charges) {
        if (!c.invoiceTitle) {
          c.invoiceTitle = await Company.getCompanyName(c.accountId)
        }
        // console.log('开票抬头3:' + c.accountId, c.invoiceTitle)
      }
    }
  }

  static sapChargeChineseNameFunc(data) {
    if (data == null) {
      return ''
    }
    return this.getSapChargeChineseName(data.sapStatus)
  }

  static getSapChargeChineseName(code) {
    let chineseName = ''
    if (code) {
      for (const c of CHARGE_SAP_LIST) {
        if (c.code === code) {
          chineseName = c.chineseName
          break
        }
      }
    }
    return chineseName
  }

  // 箱量发生改变 更新体积价
  static eqQuantityChangeHandler(job, context) {
    let isFlag = false
    const charges = []
    for (const charge of job.charges) {
      // 更新箱数的费用
      if (SEUtils.checkAdjust(charge) && charge.measure === 'CNTR') {
        charge.quantity = 0
        for (const seq of job.seaEQ) {
          charge.quantity += seq.eqQuantity
        }
        if (charge.quantity === 0) {
          charge.quantity = 1
        }
        // CARGO-4980 单价是否含税
        if (charge.unitPriceIncludeTax) {
          ChargeUtils.calculateTaxAmount(charge, charge.quantity * charge.unitRate, charge.taxRate)
        } else {
          ChargeUtils.calculateTax(charge, charge.quantity * charge.unitRate, charge.taxRate)
        }
        charges.push(charge)
        if (!isFlag) isFlag = true
      }
    }
    if (isFlag && charges.length > 0) {
      context.modifiedData.charges = context.modifiedData.charges || []
      mergeArray(context.modifiedData.charges, charges) // 只记住修改过的数据
    }
    context.reloadCharge = true
  }

  // 实际体积发生改变 更新体积价
  static caQuantityChangeHandler(job, context, q) {
    let isFlag = false
    const charges = []
    for (const charge of job.charges) {
      // 更新箱数的费用
      if (SEUtils.checkAdjust(charge) && charge.measure === 'VOL') {
        charge.quantity = q
        if (!charge.quantity || charge.quantity === 0) {
          charge.quantity = 1
        }
        // CARGO-4980 单价是否含税
        if (charge.unitPriceIncludeTax) {
          ChargeUtils.calculateTaxAmount(charge, charge.quantity * charge.unitRate, charge.taxRate)
        } else {
          ChargeUtils.calculateTax(charge, charge.quantity * charge.unitRate, charge.taxRate)
        }
        charges.push(charge)
        if (!isFlag) isFlag = true
      }
    }
    if (isFlag && charges.length > 0) {
      context.modifiedData.charges = context.modifiedData.charges || []
      mergeArray(context.modifiedData.charges, charges) // 只记住修改过的数据
    }
    context.reloadCharge = true
  }

  // 费用汇率是否需要更新
  static exchangeRateNeedUpdate(charges, businessDate) {
    const currencySet = new Set()
    for (const charge of charges) {
      const localCurrency = RateUtil.localCurrencyByOfficeId(charge.branchId)
      if (charge.currency !== localCurrency) {
        if (currencySet.has(charge.currency)) {
          continue
        }
        currencySet.add(charge.currency)
        const rate = RateUtil.getForeignExchangeRateSafely(localCurrency, charge.currency, businessDate, charge.branchId, 3)
        if (isNaN(rate) || rate === 0 || rate !== Number(charge.exchangeRate)) {
          return true
        }
      }
    }
    return false
  }

  // 包含单位为“重量价”，并且可以更新的费用
  static async weightChargesCanUpdate(job) {
    const doc = await this.getDocByChargeWeightValueType2(job)
    if (doc) {
      return []
    }
    const result = []
    const charges = job.charges
    if (!charges) {
      return result
    }
    const isXy = String(cache.config.get('ToExoSystem')) === 'XYCW'
    for (const charge of charges) {
      if (!charge.confirmBillUuid && charge.measure === ChargeMeasure.WGT_CHARGE_MEASURE.code &&
          !charge.invoiceUuid && !charge.billingUuid && !charge.billingPaymentUuid &&
          !charge.verifiedAmount && !charge.paidOff && charge.chargeState === 0 && !charge.relatedMbl &&
          ((charge.receivable && job.receivableChargeLockedStatus === 0) || (!charge.receivable && job.payableChargeLockedStatus === 0)) &&
          !(isXy && job.lob === 'SE' && BillType.MERGE_BILL_TYPE.code === job.typeHBL)) {
        result.push(charge)
      }
    }
    return result
  }

  // 校验费用取值字段
  static async checkChargeData(charge, measure, job) {
    if (!charge.confirmBillUuid && charge.measure === measure && !charge.invoiceUuid && !charge.billingUuid && !charge.billingPaymentUuid &&
        !charge.verifiedAmount && !charge.paidOff && charge.chargeState === 0 && !charge.relatedMbl &&
        ((charge.receivable && job.receivableChargeLockedStatus === 0) || (!charge.receivable && job.payableChargeLockedStatus === 0))) {
      return true
    }
    return false
  }

  // 包含单位为“重量价(吨)”，并且可以更新的费用
  static async wgttWeightChargesCanUpdate(job, weight, context) {
    const result = []
    const charges = job.charges
    if (!charges) {
      return
    }
    for (const charge of charges) {
      if (!charge.confirmBillUuid && charge.measure === ChargeMeasure.WGTT_CHARGE_MEASURE.code &&
          !charge.invoiceUuid && !charge.billingUuid && !charge.billingPaymentUuid && charge.chargeSource !== CHARGE_SOURCE_SPLIT.code &&
          !charge.verifiedAmount && !charge.paidOff && charge.chargeState === 0 && !charge.relatedMbl &&
          ((charge.receivable && job.receivableChargeLockedStatus === 0) || (!charge.receivable && job.payableChargeLockedStatus === 0))) {
        result.push(charge)
      }
    }
    if (result.length > 0) {
      await MessageBox.confirm(i18n.t('Message.WeightChangeToRefreshCostBasedOnWeightTonPrice'), {
        confirmButtonText: i18n.t('common.btn.ok'),
        cancelButtonText: i18n.t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        for (const charge of result) {
          charge.quantity = weight / 1000
          if (charge.unitPriceIncludeTax) {
            ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
          } else {
            ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
          }
        }
        context.modifiedData.charges = context.modifiedData.charges || []
        mergeArray(context.modifiedData.charges, result)
        context.reloadCharge = true
      }).catch(() => {})
    }
  }

  // 包含单位为“体积价”，并且可以更新的费用
  static async cubageChargesCanUpdate(job) {
    const doc = await this.getDocByChargeWeightValueType2(job)
    if (doc) {
      return []
    }
    const result = []
    const charges = job.charges
    if (!charges) {
      return result
    }
    const isXy = String(cache.config.get('ToExoSystem')) === 'XYCW'
    for (const charge of charges) {
      if (!charge.confirmBillUuid && charge.measure === ChargeMeasure.VOL_CHARGE_MEASURE.code &&
        !charge.invoiceUuid && !charge.billingUuid && !charge.billingPaymentUuid && !charge.diffChargeUuid &&
        !charge.verifiedAmount && !charge.paidOff && charge.chargeState === 0 && !charge.relatedMbl &&
        ((charge.receivable && job.receivableChargeLockedStatus === 0) || (!charge.receivable && job.payableChargeLockedStatus === 0)) &&
        !(isXy && job.lob === 'SE' && BillType.MERGE_BILL_TYPE.code === job.typeHBL)) {
        result.push(charge)
      }
    }
    return result
  }

  /**
   * 校验单价
   * @param rowData
   * @param view
   * @returns {Promise<boolean>}
   */
  static async checkUnitRate(rowData, view, needCheckAmount = true) {
    await cache.load(cacheName.CONFIG)
    const isInputZeroFee = parseInt(cache.config.get('InputZeroFee')) === 1
    let row
    if (isInputZeroFee) {
      if (needCheckAmount) {
        row = rowData.find(charge => isNaN(charge.unitRate) || !charge.unitRate || isNaN(charge.amount) || !charge.amount)
      } else {
        row = rowData.find(charge => isNaN(charge.unitRate) || !charge.unitRate)
      }
      if (row) {
        let tip
        if (needCheckAmount) {
          tip = view.$t('CargoMsg.Cargo_ZeroAmountWarning')
        } else {
          tip = view.$t('CargoMsg.Cargo_ZeroUnitPriceEntry')
        }
        return await view.$confirm(tip, view.$t('common.tips.prompt'), {
          confirmButtonText: view.$t('CargoMsg.Cargo_ContinueToSave'),
          cancelButtonText: view.$t('CargoMsg.Cargo_Readjust'),
          type: 'info'
        }).then(() => {
          // 继续保存
          return true
        }).catch(() => {
          // 重新调整
          return false
        })
      }
      return true
    } else {
      if (needCheckAmount) {
        row = rowData.find(charge => isNaN(charge.amount) || !charge.amount)
        if (row) {
          view.$message.warning(view.$t('Message.AmountCannotBeZero2'))
          return false
        }
      }
      row = rowData.find(charge => isNaN(charge.unitRate) || !charge.unitRate)
      if (row) {
        view.$message.warning(view.$t('Message.UnitPriceCannotBeZero'))
        return false
      }
      return true
    }
  }

  /**
   * 填写卖价 买价时，新增空运费用
   * @param job 业务
   * @param arQuantity 应收数量
   * @param apQuantity 应付数量
   * @param self 上下文
   */
  static sellingOrBuyingTipHandler(job, arQuantity, apQuantity, self) {
    const context = self.context
    if (!context || context.config.get('AESellPriceBuyPriceCreateFee') !== '1') {
      return
    }
    const selling = Number(job.selling)
    const buying = Number(job.buying)
    if (isNaN(selling) || isNaN(buying) || selling === 0 || buying === 0) {
      return
    }
    if (job && job.charges && job.charges.length > 0) {
      // 已经有费用来源为空运费,不在新增费用
      const index = job.charges.findIndex(p => p.chargeSource === CHARGE_BUYING_AND_SELLING_PRICE.code)
      if (index > -1) {
        return
      }
    }
    self.$confirm(self.$t('Message.GenerateExpensesBasedOnCurrentSellingPriceAndBuyingPrice'), self.$t('Message.Prompt'), {
      confirmButtonText: self.$t('constant.yes'),
      cancelButtonText: self.$t('constant.no'),
      closeOnClickModal: false,
      type: 'info'
    }).then(async() => {
      if (!job.charges) {
        job.charges = []
      }
      const chargeItem = getObjectByCache(basicCacheKeys.basic_data_ChargeItem, 'scaleCode', 'A/F')
      if (!chargeItem) {
        Message.warning(self.$t('Message.PlatformCodeNotFound'))
        return false
      }
      // 添加应收费用
      const chargeAr = await ChargeUtils.createNewCharge(job, chargeItem, true, selling, arQuantity)
      chargeAr.serialNumber = job.charges.filter(p => p.receivable).length + 1
      job.charges.push(chargeAr)
      // 添加应付费用
      const chargeAp = await ChargeUtils.createNewCharge(job, chargeItem, false, buying, apQuantity)
      chargeAp.serialNumber = job.charges.filter(p => !p.receivable).length + 1
      job.charges.push(chargeAp)
      context.reloadCharge = true
    })
  }
  static async createNewCharge(job, chargeItem, receivable, amount, quantity) {
    const charge = new Charge().fillDefaultValue().getData()
    if (receivable) {
      charge.uuid = 'addTabCost__' + getUuid()
    } else {
      charge.uuid = 'addTabSelling__' + getUuid()
    }
    charge.jobUuid = job.uuid
    charge.chargeItemId = chargeItem.itemId // 空运费
    // 根据收费项目 取结算单位
    ChargeUtils.setAccountIdForChargeItem(job, chargeItem, charge, receivable)
    // 根据结算对象取开票抬头
    charge.invoiceTitle = await ChargeUtils.queryTitleList(charge.accountId)
    charge.oversea = false
    const localCurrency = RateUtil.localCurrencyByOfficeId(job.opOffice)
    charge.localCurrency = localCurrency
    if (receivable && job.sellingCurrency && job.sellingCurrency.length > 0) {
      charge.currency = job.sellingCurrency
    } else if (!receivable && job.buyingCurrency && job.buyingCurrency.length > 0) {
      charge.currency = job.buyingCurrency
    } else {
      charge.currency = localCurrency
    }
    if ((receivable && job.sellPriceType === AirExportConstants.TOTAL_RRICE.code) || (!receivable && job.buyPriceType === AirExportConstants.TOTAL_RRICE.code)) {
      charge.measure = ChargeMeasure.SHIPMENT_CHARGE_MEASURE.code
      charge.quantity = 1
      charge.unitRate = amount
      charge.amount = NumberUtils.ToFixed2(amount, 2)
      await ChargeUtils.calculateExchangeRate(charge, job)
      if (charge.unitPriceIncludeTax) {
        this.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
      } else {
        this.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
      }
    } else {
      charge.exchangeRate = 1
      charge.measure = chargeItem.measure
      charge.quantity = quantity // 取值实际计费重量 或计费重量
      charge.unitRate = amount
      charge.amount = NumberUtils.ToFixed2(amount * charge.quantity, 2)
    }
    charge.receivable = receivable
    charge.excludingTaxAmount = charge.amount
    charge.settlementAgentId = charge.accountId
    charge.verifiedAmount = 0
    charge.inputDate = new Date()
    charge.inputBy = $store.getters.userId
    charge.branchId = job.opOffice
    // HQ币种/汇率
    charge.hqCurrency = RateUtil.getHqCurrency(charge.branchId)
    charge.hqRate = await RateUtil.getForeignExchangeRateByJob(charge.hqCurrency, localCurrency, job, charge.branchId)
    charge.inputByDep = job.opDepartment
    charge.businessDate = job.businessDate
    charge.isDirty = true
    charge.chargeSource = CHARGE_BUYING_AND_SELLING_PRICE.code
    return charge
  }
  static setAccountIdForChargeItem(job, chargeItem, charge, receivable) {
    // 有默认的固定结算单位，使用默认。
    if (receivable) {
      if (chargeItem.defaultArAccountId > 0 && chargeItem.defaultArCode && chargeItem.useDefaultArCode) {
        charge.accountId = chargeItem.defaultArAccountId
      } else if (chargeItem.defaultArAccountId <= 0 && chargeItem.defaultArCode && chargeItem.useDefaultArCode) {
        charge.accountId = 0
        charge.invoiceTitle = ''
      } else if (chargeItem.defaultArAccountId > 0 && !chargeItem.defaultArCode && !chargeItem.useDefaultArCode) {
        charge.accountId = chargeItem.defaultArAccountId
      } else if (chargeItem.defaultArAccountId > 0 && chargeItem.defaultArCode && !chargeItem.useDefaultArCode) {
        charge.accountId = chargeItem.defaultArAccountId
      } else if (chargeItem.defaultArAccountId <= 0 && chargeItem.defaultArCode && !chargeItem.useDefaultArCode) {
        // 根据结算对象配置 取值业务中数据
        charge.accountId = ChargeUtils.getChargeDefaultChargeItem(job, chargeItem.defaultArCode)
      }
    } else {
      if (chargeItem.defaultApAccountId > 0 && chargeItem.defaultApCode && chargeItem.useDefaultApCode) {
        charge.accountId = chargeItem.defaultApAccountId
      } else if (chargeItem.defaultApAccountId <= 0 && chargeItem.defaultApCode && chargeItem.useDefaultApCode) {
        charge.accountId = 0
        charge.invoiceTitle = ''
      } else if (chargeItem.defaultApAccountId > 0 && !chargeItem.defaultApCode && !chargeItem.useDefaultApCode) {
        charge.accountId = chargeItem.defaultApAccountId
      } else if (chargeItem.defaultApAccountId > 0 && chargeItem.defaultApCode && !chargeItem.useDefaultApCode) {
        charge.accountId = chargeItem.defaultApAccountId
      } else if (chargeItem.defaultApAccountId <= 0 && chargeItem.defaultApCode && !chargeItem.useDefaultApCode) {
        charge.accountId = ChargeUtils.getChargeDefaultChargeItem(job, chargeItem.defaultApCode)
      }
    }
  }
  // 查询开票抬头
  static async queryTitleList(accountId) {
    return queryTitleByCpmIdx(accountId).then((res) => {
      let titleArray = []
      if (res.data && res.data.length > 0) {
        titleArray = res.data
      }
      this.titleArray = titleArray
      // 根据结算对象ID获取结算对象
      const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(accountId))
      if (company) {
        // 设置默认值
        if (!titleArray || titleArray.length === 0) {
          return ChargeUtils.getCompanyName(company)
        } else {
          // 根据配置优先取默认值
          for (let i = 0; i < titleArray.length; i++) {
            const item = titleArray[i]
            if (item['defaultTitle'] === true) {
              return item['title']
            }
          }
          return titleArray[0].title
        }
      }
    })
  }
  static getCompanyName(company) {
    // 返回国际化
    if (company) {
      if ($store.getters.language === 'zh') {
        if (company.chineseName && company.chineseName.trim() === '') {
          return company.englishName || ''
        }
        return company.chineseName || ''
      } else {
        return company.englishName || ''
      }
    }
    return ''
  }
  // 根据开票抬头更新国内国外
  static updateOverseaByInvoiceTitle(charge, invoiceTitleList) {
    if (!invoiceTitleList) {
      return false
    }
    const invoiceTitle = invoiceTitleList.find(p => p.title === charge.invoiceTitle)
    if (!invoiceTitle) {
      return false
    }
    if (invoiceTitle.oversea === 'internal') {
      charge.oversea = false
    } else if (invoiceTitle.oversea === 'oversea') {
      charge.oversea = true
    }
    return true
  }
  // 根据结算对象更新国内国外
  static async updateOverseaByAccountId(charge) {
    const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(charge.accountId))
    if (company) {
      await getCustomer({ companyUuid: company.uuid }).then(res => {
        const customer = res.data
        if (customer) {
          if (customer.oversea === 'internal') {
            charge.oversea = false
          } else if (customer.oversea === 'oversea') {
            charge.oversea = true
          }
        }
      })
    }
  }
  /**
   * 获取应收/应付费用最大序号, 费用序号最小是1
   * @param charges
   * @param isAr
   * @returns {number}
   */
  static getMaxSerialNumber(charges = [], isAr = true) {
    let max = 0
    if (charges && charges.length > 0) {
      for (const c of charges) {
        if (isAr === c.receivable) {
          if (c.serialNumber > max) {
            max = c.serialNumber
          }
        }
      }
    }
    if (max === 0) {
      max = 1
    }
    return max
  }
  // 获取结算对象维护的开票抬头
  static async getTitleListByCompanyCmpIdx(accountId) {
    const titleList = []
    await queryTitleByCpmIdx(accountId).then((res) => {
      if (res.data && res.data.length > 0) {
        for (const title of res.data) {
          if (!title.title) continue
          title.invoiceTitle = title.title
          titleList.push(title)
        }
      }
    })
    return titleList
  }
  /**
   * 获取原币合计为0的币种
   */
  static getZeroAmountCurrencys(chargeList, currencyField = 'currency', amountField = 'amount', arApField = 'receivable') {
    try {
      const currencys = []
      const currencyAmountMap = {}
      for (const charge of chargeList) {
        // 币种
        const chargeCurrency = charge[currencyField]
        if (!currencyAmountMap.hasOwnProperty(chargeCurrency)) currencyAmountMap[chargeCurrency] = 0
        // 金额
        const chargeAmount = RateUtil.getAmountByCurrency(charge[arApField] ? charge[amountField] : -charge[amountField], chargeCurrency)
        // 合计
        currencyAmountMap[chargeCurrency] = RateUtil.getAmountByCurrency(chargeAmount + currencyAmountMap[chargeCurrency], chargeCurrency)
      }
      Object.keys(currencyAmountMap).forEach(key => {
        if (currencyAmountMap[key] === 0) currencys.push(key)
      })
      // console.log('getZeroAmountCurrencys', currencyAmountMap)
      return currencys
    } catch (e) {
      return []
    }
  }

  /**
   * 校验费用的费用项目是否存在可用税率，若存在校验费用的税率是否在范围内
   */
  static checkChargeRateRange(charge) {
    const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
    let message = ''
    if (chargeItem && chargeItem.active && chargeItem.rateRange) {
      let check = false
      for (const item of chargeItem.rateRange.split(',')) {
        if (Number(item) === Number(charge.taxRate)) {
          check = true
        }
      }
      if (!check) {
        message = chargeItem.zhName + '[' + chargeItem.chargecode + ']'
      }
    }
    return message
  }

  /**
   * 获取参数【ChargeWeightValueType】的值（因为多个地方的用法不一致，部分场景需做兼容处理，避免影响现有逻辑）
   * @param compatMode 如果为true，将新加的参数值2转为0
   * @returns
   */
  static getChargeWeightValueType(compatMode = false) {
    if (!cache.config) {
      return 0
    }
    const val = Number(cache.config.get('ChargeWeightValueType')) || 0
    if (compatMode && val === 2) {
      return 0
    }
    return val
  }

  /**
   * 参数【ChargeWeightValueType】=2时，获取对应提单（取值优先级：HBL并单 > HBL > MBL并单 > MBL）
   * @param job
   * @returns
   */
  static async getDocByChargeWeightValueType2(job) {
    if (!job) {
      return null
    }
    if (!['SE', 'SI'].includes(job.lob)) {
      return null
    }
    const chargeWeightValueType = this.getChargeWeightValueType(false)
    if (chargeWeightValueType !== 2) {
      return null
    }
    let cargoDocList = null
    if (job.lob === 'SE') {
      cargoDocList = await new SeaExportJob(job).getSeaCargoDoc()
    } else if (job.lob === 'SI') {
      cargoDocList = await new SeaImportJob(job).getSeaCargoDoc()
    }
    if (!cargoDocList) {
      return null
    }
    let mergeHbl = null
    let hbl = null
    let mergeMbl = null
    let mbl = null
    const isLclMaster = !!job.lclMasterUuid
    const isNew = !job.uuid
    const masterFlag = job.masterFlag
    const isBuyerConsoleFcl = job.containerLoadType === 'BCF'
    for (const doc of cargoDocList) {
      if (doc.docType === CargoDocConsts.HBL2 && job.typeHBL === BillType.MERGE_BILL_TYPE.code) {
        if (!(isLclMaster && isNew) && !job.mblOnly && !isNew) {
          mergeHbl = doc
        }
        break
      }
      if (doc.docType === CargoDocConsts.HBL) {
        if (!(isLclMaster && isNew) && job.signHBL && !job.mblOnly) {
          if (job.lob === 'SE' && (!masterFlag || isBuyerConsoleFcl)) {
            hbl = doc
          } else if (job.lob === 'SI' && !masterFlag) {
            hbl = doc
          }
        }
        continue
      }
      if (doc.docType === CargoDocConsts.MBL2 && job.typeMBL === BillType.MERGE_BILL_TYPE.code) {
        if (!(isLclMaster && isNew) && !isNew) {
          mergeMbl = doc
        }
        continue
      }
      if (doc.docType === CargoDocConsts.MBL) {
        if (!(isLclMaster && isNew) && (masterFlag || job.signMBL)) {
          mbl = doc
        }
        continue
      }
    }
    return mergeHbl || hbl || mergeMbl || mbl
  }

  /**
   * 参数【ChargeWeightValueType】=2时，获取对应计费数量，否则返回原值
   * @param job
   * @param originQuantity 原始的计费数量
   * @param measure 计费单位
   * @returns
   */
  static async getQuantityByChargeWeightValueType2(job, originQuantity, measure) {
    if (!job || !measure) {
      return originQuantity
    }
    const chargeWeightValueType = this.getChargeWeightValueType(false)
    if (chargeWeightValueType === 2) {
      const doc = await this.getDocByChargeWeightValueType2(job)
      if (doc) {
        switch (measure) {
          case ChargeMeasure.WGT_CHARGE_MEASURE.code: {
            return doc.weight
          }
          case ChargeMeasure.VOL_CHARGE_MEASURE.code: {
            return doc.cubage
          }
          case ChargeMeasure.PIECE_CHARGE_MEASURE.code: {
            return doc.quantity
          }
          case ChargeMeasure.WGTX_CHARGE_MEASURE.code: {
            return doc.chargeWeight
          }
        }
      } else {
        switch (measure) {
          case ChargeMeasure.WGT_CHARGE_MEASURE.code: {
            return job.weightActual
          }
          case ChargeMeasure.VOL_CHARGE_MEASURE.code: {
            return job.cubageActual
          }
          case ChargeMeasure.PIECE_CHARGE_MEASURE.code: {
            return job.quantityActual
          }
          case ChargeMeasure.WGTX_CHARGE_MEASURE.code: {
            return job.chargeWeight
          }
        }
      }
    }
    return originQuantity
  }

  /**
   * 费用是否可修改
   * @param charge
   * @param job
   * @returns
   */
  static async chargeIsModified(charge, job) {
    if (charge && job) {
      if ((job.uuid && !charge.jobUuid) || charge.jobUuid !== job.uuid || charge.verifiedAmount !== 0 || charge.billingUuid ||
        charge.billingPaymentUuid || charge.invoiceUuid || charge.shared || charge.collection ||
        (charge.chargeState !== 0 && charge.chargeState !== 3) || !await this.checkRoleEdit(charge) || charge.confirmState === 1 ||
        charge.agentSharedBillingUuid) { // !shareEnable
        return false
      }
      if (charge.shareScheme > 0) {
        return false
      }
    }
    return true
  }

  /**
   * 是否同组和全部编辑权限
   * @param charge
   * @returns
   */
  static async checkRoleEdit(charge) {
    if (charge.createdBy === 0 || charge.inputBy === $store.getters.userId || charge.createdBy === $store.getters.userId) {
      return true
    }
    const editArAllCharge = checkPermission(['role_Charge_editArAllCharge'])
    const editArDeptCharge = checkPermission(['role_Charge_editArDeptCharge'])
    const editApAllCharge = checkPermission(['role_Charge_editApAllCharge'])
    const editApDeptCharge = checkPermission(['role_Charge_editApDeptCharge'])
    if (charge.receivable) {
      if (editArAllCharge) {
        return true
      }
      if (editArDeptCharge && await this.checkDepartmentTeam(charge)) {
        return true
      }
    } else {
      if (editApAllCharge) {
        return true
      }
      if (editApDeptCharge && await this.checkDepartmentTeam(charge)) {
        return true
      }
    }
    return false
  }

  /**
   * 同组用户
   */
  static departmentTeamUser = null

  /**
   * 校验同组
   * @param charge
   * @returns
   */
  static async checkDepartmentTeam(charge) {
    if (charge.createdBy === 0 || charge.inputBy === $store.getters.userId || charge.createdBy === $store.getters.userId) {
      return true
    }
    if (!this.departmentTeamUser) {
      this.departmentTeamUser = await User.getUserDepartmentTeam()
    }
    for (const userId of this.departmentTeamUser) {
      if (userId === charge.inputBy || userId === charge.createdBy) {
        return true
      }
    }
    return false
  }

  /**
   * 校验费用是否被其他费用引用
   * @param charge
   * @returns
   */
  static async chargeIsDeleted(charge, lob, jobChargeCache) {
    if (!await this.chargeIsModified(charge, { uuid: charge.jobUuid })) {
      return false
    }
    if (charge.receivable) {
      if (!this.checkDeletePersonalArCharge(charge, lob)) {
        return false
      }
    } else {
      if (!this.checkDeletePersonalApCharge(charge, lob)) {
        return false
      }
    }
    const charges = (jobChargeCache.get(charge.jobUuid) || []).filter(p => p.receivable === charge.receivable)
    if (!this.checkDeleteCharges(charges, charges) || !await this.checkRoleDelete(charge)) {
      return false
    }
    // 同步的费用不可删除
    if (charge.syncStatus === 1) {
      return false
    }
    return true
  }

  /**
   * 校验应收删除个人费用权限
   */
  static checkDeletePersonalArCharge(charge, lob) {
    if (!charge) {
      return false
    }
    if (lob === 'SE' && charge.uuid && (charge.createdBy === 0 || charge.inputBy === $store.getters.userId || charge.createdBy === $store.getters.userId)) {
      return checkPermission(['role_Charge_deletePersonalArCharge'])
    }
    return true
  }

  /**
   * 校验应付删除个人费用权限
   */
  static checkDeletePersonalApCharge(charge, lob) {
    if (!charge) {
      return false
    }
    if (lob === 'SE' && charge.uuid && (charge.createdBy === 0 || charge.inputBy === $store.getters.userId || charge.createdBy === $store.getters.userId)) {
      return checkPermission(['role_Charge_deletePersonalApCharge'])
    }
    return true
  }

  /**
   * 删除费用时，校验费用UUID是否为其他费用的DIFF_CHAREG_UUID
   * @param chooseRows
   * @param allRows
   * @returns {boolean}
   */
  static checkDeleteCharges(chooseRows, allRows) {
    const diffChargeUuidMap = new Map()
    if (allRows && allRows.length > 0) {
      for (const curRow of allRows) {
        if (!curRow.diffChargeUuid) continue
        diffChargeUuidMap.set(curRow.diffChargeUuid, curRow.diffChargeUuid)
      }
    }
    if (chooseRows && chooseRows.length > 0) {
      for (const curRow of chooseRows) {
        const chargeUuid = diffChargeUuidMap.has(curRow.uuid) ? diffChargeUuidMap.get(curRow.uuid) : null
        if (chargeUuid && chargeUuid === curRow.uuid) {
          return false
        }
      }
    }
    return true
  }

  /**
   * 是否同组和全部删除权限
   */
  static async checkRoleDelete(charge) {
    if (!charge.createdBy || charge.createdBy === 0 || charge.inputBy === $store.getters.userId || charge.createdBy === $store.getters.userId) {
      return true
    }
    if (charge.receivable) {
      if (checkPermission(['role_Charge_deleteArAllCharge'])) {
        return true
      }

      if (checkPermission(['role_Charge_deleteArDeptCharge']) && await this.checkDepartmentTeam(charge)) {
        return true
      }
    } else {
      if (checkPermission(['role_Charge_deleteApAllCharge'])) {
        return true
      }

      if (checkPermission(['role_Charge_deleteApDeptCharge']) && await this.checkDepartmentTeam(charge)) {
        return true
      }
    }
    return false
  }
}
export default ChargeUtils
